// @ts-nocheck
import {
  z as zod
} from 'zod';

/**
 * @summary adminCreate
 */
export const adminCreateBodyPasswordMin = 8;

export const adminCreateBodyPasswordRegExp = new RegExp('^[0-9A-Za-z]+$');
export const adminCreateBodyNameKanaMax = 255;

export const adminCreateBodyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const adminCreateBodyDepartmentMax = 255;
export const adminCreateBodyRoleMax = 255;

export const adminCreateBodyRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const adminCreateBody = zod.object({
  "organizationId": zod.string().describe('所属させる組織。ロールはこの組織に定義されている必要がある'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "password": zod.string().min(adminCreateBodyPasswordMin).regex(adminCreateBodyPasswordRegExp),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(adminCreateBodyNameKanaMax).regex(adminCreateBodyNameKanaRegExp).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(adminCreateBodyDepartmentMax).nullable().describe('所属部署名'),
  "role": zod.string().min(1).max(adminCreateBodyRoleMax).regex(adminCreateBodyRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)')
})


/**
 * @summary adminList
 */
export const adminListQueryPageDefault = 1;export const adminListQueryLimitDefault = 10;export const adminListQueryRoleMax = 255;

export const adminListQueryRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const adminListQueryParams = zod.object({
  "page": zod.number().default(adminListQueryPageDefault),
  "limit": zod.number().default(adminListQueryLimitDefault),
  "id": zod.string().optional(),
  "nameLike": zod.string().optional(),
  "nameKanaLike": zod.string().optional(),
  "role": zod.string().min(1).max(adminListQueryRoleMax).regex(adminListQueryRoleRegExp).optional().describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)')
})

export const adminListResponseAdminsItemNameKanaMax = 255;
export const adminListResponseAdminsItemDepartmentMax = 255;
export const adminListResponseAdminsItemRoleMax = 255;

export const adminListResponseAdminsItemRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const adminListResponse = zod.object({
  "total": zod.number(),
  "admins": zod.array(zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(adminListResponseAdminsItemNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(adminListResponseAdminsItemDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(adminListResponseAdminsItemRoleMax).regex(adminListResponseAdminsItemRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}))
})


/**
 * @summary adminGet
 */
export const adminGetParams = zod.object({
  "id": zod.string()
})

export const adminGetResponseAdminNameKanaMax = 255;
export const adminGetResponseAdminDepartmentMax = 255;
export const adminGetResponseAdminRoleMax = 255;

export const adminGetResponseAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const adminGetResponse = zod.object({
  "admin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(adminGetResponseAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(adminGetResponseAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(adminGetResponseAdminRoleMax).regex(adminGetResponseAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
})
})


/**
 * @summary adminUpdate
 */
export const adminUpdateParams = zod.object({
  "id": zod.string()
})

export const adminUpdateBodyNameKanaMax = 255;

export const adminUpdateBodyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const adminUpdateBodyDepartmentMax = 255;
export const adminUpdateBodyPasswordMin = 8;

export const adminUpdateBodyPasswordRegExp = new RegExp('^[0-9A-Za-z]+$');


export const adminUpdateBody = zod.object({
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(adminUpdateBodyNameKanaMax).regex(adminUpdateBodyNameKanaRegExp).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(adminUpdateBodyDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "password": zod.string().min(adminUpdateBodyPasswordMin).regex(adminUpdateBodyPasswordRegExp).optional()
})


/**
 * @summary adminDelete
 */
export const adminDeleteParams = zod.object({
  "id": zod.string()
})


/**
 * @summary echoesSync
 */
export const echoesSyncBody = zod.object({
  "echoes_owner_id": zod.string(),
  "occurred_at": zod.string()
})


/**
 * @summary ファイルアップロード用署名付きURL取得
 */
export const filePutSignedUrlBody = zod.object({
  "contentType": zod.enum(['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/heic', 'image/heif']).describe('MIMEタイプ')
})

export const filePutSignedUrlResponse = zod.object({
  "signedUrl": zod.object({
  "key": zod.string(),
  "url": zod.string()
})
})


/**
 * @summary mePermissionList
 */
export const mePermissionListResponseRoleMax = 255;

export const mePermissionListResponseRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const mePermissionListResponse = zod.object({
  "organizationId": zod.string().describe('操作者自身が所属している組織'),
  "role": zod.string().min(1).max(mePermissionListResponseRoleMax).regex(mePermissionListResponseRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "roleLabel": zod.string().describe('ロールの表示名。複数ロールのときはカンマ区切りで並べる'),
  "screens": zod.array(zod.object({
  "screenId": zod.enum(['login', 'admin_users', 'properties', 'rooms', 'owners', 'tenants', 'tenant_applicants', 'notifications', 'tickets', 'payments', 'roles', 'organizations', 'user_profile']),
  "actions": zod.array(zod.enum(['create', 'read', 'update', 'delete']))
}))
})


/**
 * @summary organizationList
 */
export const organizationListResponseOrganizationsItemNameMax = 255;
export const organizationListResponseOrganizationsItemSlugMax = 255;

export const organizationListResponseOrganizationsItemSlugRegExp = new RegExp('^[a-z0-9][a-z0-9-]*$');


export const organizationListResponse = zod.object({
  "organizations": zod.array(zod.object({
  "id": zod.string().describe('組織ID'),
  "name": zod.string().min(1).max(organizationListResponseOrganizationsItemNameMax).describe('組織名'),
  "slug": zod.string().min(1).max(organizationListResponseOrganizationsItemSlugMax).regex(organizationListResponseOrganizationsItemSlugRegExp).describe('組織を識別する一意な値'),
  "createdAt": zod.string().describe('作成日時'),
  "memberCount": zod.number().optional().describe('組織に所属する管理者数（withMembers 指定時のみ含まれる）'),
  "roleCount": zod.number().optional().describe('組織に定義されたロール数（withRoles 指定時のみ含まれる）'),
  "ipRestrictionEnabled": zod.boolean().optional().describe('IPアドレス制限が有効か（withIpRestriction 指定時のみ含まれる）')
}))
})


/**
 * @summary organizationCreate
 */
export const organizationCreateBodyNameMax = 255;
export const organizationCreateBodySlugMax = 255;

export const organizationCreateBodySlugRegExp = new RegExp('^[a-z0-9][a-z0-9-]*$');


export const organizationCreateBody = zod.object({
  "name": zod.string().min(1).max(organizationCreateBodyNameMax).describe('組織名'),
  "slug": zod.string().min(1).max(organizationCreateBodySlugMax).regex(organizationCreateBodySlugRegExp).describe('組織を識別する一意な値')
})


/**
 * @summary organizationUpdate
 */
export const organizationUpdateParams = zod.object({
  "id": zod.string().describe('組織ID')
})

export const organizationUpdateBodyNameMax = 255;
export const organizationUpdateBodySlugMax = 255;

export const organizationUpdateBodySlugRegExp = new RegExp('^[a-z0-9][a-z0-9-]*$');


export const organizationUpdateBody = zod.object({
  "name": zod.string().min(1).max(organizationUpdateBodyNameMax).describe('組織名'),
  "slug": zod.string().min(1).max(organizationUpdateBodySlugMax).regex(organizationUpdateBodySlugRegExp).describe('組織を識別する一意な値')
})


/**
 * @summary organizationIpRestrictionGet
 */
export const organizationIpRestrictionGetParams = zod.object({
  "id": zod.string().describe('組織ID')
})

export const organizationIpRestrictionGetResponseIpRestrictionAllowedIpsItemDescriptionMax = 255;


export const organizationIpRestrictionGetResponse = zod.object({
  "ipRestriction": zod.object({
  "organizationId": zod.string().describe('組織ID'),
  "enabled": zod.boolean().describe('IPアドレス制限を有効にするか'),
  "allowedIps": zod.array(zod.object({
  "id": zod.string().describe('許可IPアドレスID'),
  "cidr": zod.string().describe('正規化済みのCIDR'),
  "description": zod.string().max(organizationIpRestrictionGetResponseIpRestrictionAllowedIpsItemDescriptionMax).describe('許可するIPアドレスの説明'),
  "createdAt": zod.string().describe('作成日時')
})),
  "updatedAt": zod.string().nullable().describe('最終更新日時。一度も設定していない組織は null')
}),
  "currentIp": zod.string().nullable().describe('操作者の接続元IPアドレス。取得できない場合は null')
})


/**
 * @summary organizationIpRestrictionUpdate
 */
export const organizationIpRestrictionUpdateParams = zod.object({
  "id": zod.string().describe('組織ID')
})

export const organizationIpRestrictionUpdateBodyAllowedIpsItemCidrMax = 49;
export const organizationIpRestrictionUpdateBodyAllowedIpsItemDescriptionMax = 255;
export const organizationIpRestrictionUpdateBodyAllowedIpsMax = 100;


export const organizationIpRestrictionUpdateBody = zod.object({
  "enabled": zod.boolean().describe('IPアドレス制限を有効にするか'),
  "allowedIps": zod.array(zod.object({
  "cidr": zod.string().min(1).max(organizationIpRestrictionUpdateBodyAllowedIpsItemCidrMax).describe('許可するIPアドレスまたはCIDR。保存時にネットワークアドレスへ正規化される'),
  "description": zod.string().max(organizationIpRestrictionUpdateBodyAllowedIpsItemDescriptionMax).describe('許可するIPアドレスの説明')
})).max(organizationIpRestrictionUpdateBodyAllowedIpsMax)
})


/**
 * @summary ownerGet
 */
export const ownerGetParams = zod.object({
  "id": zod.string()
})

export const ownerGetQueryParams = zod.object({
  "withProperties": zod.enum(['true', 'false']).optional(),
  "withPropertiesRooms": zod.enum(['true', 'false']).optional(),
  "withPropertiesRoomsTenants": zod.enum(['true', 'false']).optional(),
  "withPropertiesRoomsPlans": zod.enum(['true', 'false']).optional(),
  "withOperationRules": zod.enum(['true', 'false']).optional(),
  "withOperationRulesOperationRuleLogs": zod.enum(['true', 'false']).optional()
})

export const ownerGetResponseOwnerPropertiesItemNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerGetResponseOwnerPropertiesItemNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerGetResponseOwnerPropertiesItemPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerGetResponseOwnerPropertiesItemCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerGetResponseOwnerPropertiesItemTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const ownerGetResponseOwnerPropertiesItemDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const ownerGetResponse = zod.object({
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(ownerGetResponseOwnerPropertiesItemNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(ownerGetResponseOwnerPropertiesItemNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(ownerGetResponseOwnerPropertiesItemPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(ownerGetResponseOwnerPropertiesItemCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(ownerGetResponseOwnerPropertiesItemTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(ownerGetResponseOwnerPropertiesItemDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.any().nullish().describe('物件を所有するオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "operationRules": zod.array(zod.object({
  "agentCallContractorApproval": zod.enum(['agree', 'disagree']).describe('エージェントコール業者による手配の承諾可否（agree:承諾する / disagree:承諾しない）'),
  "hasDesignatedContractor": zod.enum(['exists', 'none']).describe('オーナー指定業者の有無（exists:あり / none:なし）'),
  "arrangementLimit": zod.union([zod.literal('30000'),zod.literal('50000'),zod.literal('70000'),zod.literal('100000'),zod.literal('all_estimate'),zod.literal('confirm_required'),zod.literal(null)]).nullable().describe('業者手配を任せられる上限金額（all_estimate:全件見積を取る / 30000・50000・70000・100000:上限額(円) / confirm_required:都度確認）'),
  "designatedContractors": zod.array(zod.object({
  "name": zod.string().describe('業者名'),
  "contactPerson": zod.string().nullable().describe('業者の担当者名'),
  "categories": zod.array(zod.enum(['general', 'interior', 'plumbing', 'water_heater', 'air_conditioner', 'other_appliances', 'electrical'])).describe('対応カテゴリ（general:総合 / interior:内装 / plumbing:水道 / water_heater:給湯器 / air_conditioner:エアコン / other_appliances:その他設備 / electrical:電気）'),
  "otherCategory": zod.string().nullable().describe('categories に該当がない場合の自由記述カテゴリ'),
  "contactInfo": zod.string().describe('連絡先（依頼方法に対応する電話番号 / メールアドレス / FAX番号）'),
  "requestMethod": zod.enum(['email', 'fax', 'phone']).describe('依頼方法（email:メール / fax:FAX / phone:電話）'),
  "address": zod.string().nullable().describe('業者の住所'),
  "note": zod.string().nullable().describe('備考（営業時間など）')
})).describe('オーナー指定業者の一覧'),
  "id": zod.number().describe('運用ルールID'),
  "ownerId": zod.string().describe('オーナーID'),
  "propertyId": zod.number().nullable().describe('物件ID。null はオーナー既定ルール、値ありは物件固有ルール'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "operationRuleLogs": zod.array(zod.object({
  "agentCallContractorApproval": zod.enum(['agree', 'disagree']).describe('エージェントコール業者による手配の承諾可否（agree:承諾する / disagree:承諾しない）'),
  "hasDesignatedContractor": zod.enum(['exists', 'none']).describe('オーナー指定業者の有無（exists:あり / none:なし）'),
  "arrangementLimit": zod.union([zod.literal('30000'),zod.literal('50000'),zod.literal('70000'),zod.literal('100000'),zod.literal('all_estimate'),zod.literal('confirm_required'),zod.literal(null)]).nullable().describe('業者手配を任せられる上限金額（all_estimate:全件見積を取る / 30000・50000・70000・100000:上限額(円) / confirm_required:都度確認）'),
  "designatedContractors": zod.array(zod.object({
  "name": zod.string().describe('業者名'),
  "contactPerson": zod.string().nullable().describe('業者の担当者名'),
  "categories": zod.array(zod.enum(['general', 'interior', 'plumbing', 'water_heater', 'air_conditioner', 'other_appliances', 'electrical'])).describe('対応カテゴリ（general:総合 / interior:内装 / plumbing:水道 / water_heater:給湯器 / air_conditioner:エアコン / other_appliances:その他設備 / electrical:電気）'),
  "otherCategory": zod.string().nullable().describe('categories に該当がない場合の自由記述カテゴリ'),
  "contactInfo": zod.string().describe('連絡先（依頼方法に対応する電話番号 / メールアドレス / FAX番号）'),
  "requestMethod": zod.enum(['email', 'fax', 'phone']).describe('依頼方法（email:メール / fax:FAX / phone:電話）'),
  "address": zod.string().nullable().describe('業者の住所'),
  "note": zod.string().nullable().describe('備考（営業時間など）')
})).describe('オーナー指定業者の一覧'),
  "id": zod.number().describe('運用ルールID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "deleted": zod.boolean().optional().describe('物件固有ルールを削除した記録の場合 true(削除直前の内容を snapshot として保持)')
})).optional().describe('このスコープの運用ルール変更履歴(保存ごとのスナップショット、新しい順)。withOperationRuleLogs 指定時のみ含まれる')
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})
})


/**
 * @summary ownerUpdate
 */
export const ownerUpdateParams = zod.object({
  "id": zod.string()
})

export const ownerUpdateBodyEmergencyPhoneNumberDefault = null;

export const ownerUpdateBody = zod.object({
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullish().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項')
})


/**
 * @summary ownerList
 */
export const ownerListQueryPageDefault = 1;export const ownerListQueryLimitDefault = 10;

export const ownerListQueryParams = zod.object({
  "page": zod.number().default(ownerListQueryPageDefault),
  "limit": zod.number().default(ownerListQueryLimitDefault),
  "id": zod.string().optional(),
  "nameLike": zod.string().optional(),
  "nameKanaLike": zod.string().optional(),
  "emailLike": zod.string().optional(),
  "phoneNumberLike": zod.string().optional(),
  "isEchoesOwner": zod.enum(['true', 'false']).optional(),
  "withProperties": zod.enum(['true', 'false']).optional(),
  "withPropertiesRooms": zod.enum(['true', 'false']).optional(),
  "withPropertiesRoomsTenants": zod.enum(['true', 'false']).optional(),
  "withPropertiesRoomsPlans": zod.enum(['true', 'false']).optional(),
  "withOperationRules": zod.enum(['true', 'false']).optional(),
  "withOperationRulesOperationRuleLogs": zod.enum(['true', 'false']).optional()
})

export const ownerListResponseOwnersItemPropertiesItemNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerListResponseOwnersItemPropertiesItemNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerListResponseOwnersItemPropertiesItemPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerListResponseOwnersItemPropertiesItemCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ownerListResponseOwnersItemPropertiesItemTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const ownerListResponseOwnersItemPropertiesItemDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const ownerListResponse = zod.object({
  "total": zod.number(),
  "owners": zod.array(zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(ownerListResponseOwnersItemPropertiesItemNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(ownerListResponseOwnersItemPropertiesItemNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(ownerListResponseOwnersItemPropertiesItemPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(ownerListResponseOwnersItemPropertiesItemCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(ownerListResponseOwnersItemPropertiesItemTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(ownerListResponseOwnersItemPropertiesItemDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.any().nullish().describe('物件を所有するオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "operationRules": zod.array(zod.object({
  "agentCallContractorApproval": zod.enum(['agree', 'disagree']).describe('エージェントコール業者による手配の承諾可否（agree:承諾する / disagree:承諾しない）'),
  "hasDesignatedContractor": zod.enum(['exists', 'none']).describe('オーナー指定業者の有無（exists:あり / none:なし）'),
  "arrangementLimit": zod.union([zod.literal('30000'),zod.literal('50000'),zod.literal('70000'),zod.literal('100000'),zod.literal('all_estimate'),zod.literal('confirm_required'),zod.literal(null)]).nullable().describe('業者手配を任せられる上限金額（all_estimate:全件見積を取る / 30000・50000・70000・100000:上限額(円) / confirm_required:都度確認）'),
  "designatedContractors": zod.array(zod.object({
  "name": zod.string().describe('業者名'),
  "contactPerson": zod.string().nullable().describe('業者の担当者名'),
  "categories": zod.array(zod.enum(['general', 'interior', 'plumbing', 'water_heater', 'air_conditioner', 'other_appliances', 'electrical'])).describe('対応カテゴリ（general:総合 / interior:内装 / plumbing:水道 / water_heater:給湯器 / air_conditioner:エアコン / other_appliances:その他設備 / electrical:電気）'),
  "otherCategory": zod.string().nullable().describe('categories に該当がない場合の自由記述カテゴリ'),
  "contactInfo": zod.string().describe('連絡先（依頼方法に対応する電話番号 / メールアドレス / FAX番号）'),
  "requestMethod": zod.enum(['email', 'fax', 'phone']).describe('依頼方法（email:メール / fax:FAX / phone:電話）'),
  "address": zod.string().nullable().describe('業者の住所'),
  "note": zod.string().nullable().describe('備考（営業時間など）')
})).describe('オーナー指定業者の一覧'),
  "id": zod.number().describe('運用ルールID'),
  "ownerId": zod.string().describe('オーナーID'),
  "propertyId": zod.number().nullable().describe('物件ID。null はオーナー既定ルール、値ありは物件固有ルール'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "operationRuleLogs": zod.array(zod.object({
  "agentCallContractorApproval": zod.enum(['agree', 'disagree']).describe('エージェントコール業者による手配の承諾可否（agree:承諾する / disagree:承諾しない）'),
  "hasDesignatedContractor": zod.enum(['exists', 'none']).describe('オーナー指定業者の有無（exists:あり / none:なし）'),
  "arrangementLimit": zod.union([zod.literal('30000'),zod.literal('50000'),zod.literal('70000'),zod.literal('100000'),zod.literal('all_estimate'),zod.literal('confirm_required'),zod.literal(null)]).nullable().describe('業者手配を任せられる上限金額（all_estimate:全件見積を取る / 30000・50000・70000・100000:上限額(円) / confirm_required:都度確認）'),
  "designatedContractors": zod.array(zod.object({
  "name": zod.string().describe('業者名'),
  "contactPerson": zod.string().nullable().describe('業者の担当者名'),
  "categories": zod.array(zod.enum(['general', 'interior', 'plumbing', 'water_heater', 'air_conditioner', 'other_appliances', 'electrical'])).describe('対応カテゴリ（general:総合 / interior:内装 / plumbing:水道 / water_heater:給湯器 / air_conditioner:エアコン / other_appliances:その他設備 / electrical:電気）'),
  "otherCategory": zod.string().nullable().describe('categories に該当がない場合の自由記述カテゴリ'),
  "contactInfo": zod.string().describe('連絡先（依頼方法に対応する電話番号 / メールアドレス / FAX番号）'),
  "requestMethod": zod.enum(['email', 'fax', 'phone']).describe('依頼方法（email:メール / fax:FAX / phone:電話）'),
  "address": zod.string().nullable().describe('業者の住所'),
  "note": zod.string().nullable().describe('備考（営業時間など）')
})).describe('オーナー指定業者の一覧'),
  "id": zod.number().describe('運用ルールID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "deleted": zod.boolean().optional().describe('物件固有ルールを削除した記録の場合 true(削除直前の内容を snapshot として保持)')
})).optional().describe('このスコープの運用ルール変更履歴(保存ごとのスナップショット、新しい順)。withOperationRuleLogs 指定時のみ含まれる')
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}))
})


/**
 * @summary ownerUpdateAdminMemo
 */
export const ownerUpdateAdminMemoParams = zod.object({
  "id": zod.string()
})

export const ownerUpdateAdminMemoBody = zod.object({
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）')
})


/**
 * @summary permissionList
 */
export const permissionListResponse = zod.object({
  "resources": zod.array(zod.object({
  "resource": zod.string(),
  "screenId": zod.union([zod.literal('login'),zod.literal('admin_users'),zod.literal('properties'),zod.literal('rooms'),zod.literal('owners'),zod.literal('tenants'),zod.literal('tenant_applicants'),zod.literal('notifications'),zod.literal('tickets'),zod.literal('payments'),zod.literal('roles'),zod.literal('organizations'),zod.literal('user_profile'),zod.literal(null)]).nullable().describe('対応する画面。無い場合は null'),
  "label": zod.string(),
  "actions": zod.array(zod.enum(['create', 'read', 'update', 'delete']))
}))
})


/**
 * @summary planExportRakuten
 */
export const planExportRakutenQueryParams = zod.object({
  "activeDateFrom": zod.string().optional(),
  "activeDateTo": zod.string().optional()
})


/**
 * @summary planGet
 */
export const planGetParams = zod.object({
  "id": zod.string()
})

export const planGetQueryParams = zod.object({
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withTenant": zod.enum(['true', 'false']).optional(),
  "withTenantFiles": zod.enum(['true', 'false']).optional(),
  "withRoomProperty": zod.enum(['true', 'false']).optional()
})

export const planGetResponsePlanStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planGetResponsePlanEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planGetResponsePlanRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const planGetResponsePlanRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const planGetResponsePlanRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const planGetResponsePlanRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const planGetResponsePlanRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const planGetResponsePlanRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const planGetResponsePlanTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const planGetResponsePlanTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planGetResponsePlanTenantPhone1Max = 4;

export const planGetResponsePlanTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const planGetResponsePlanTenantPhone2Max = 4;

export const planGetResponsePlanTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const planGetResponsePlanTenantPhone3Max = 4;

export const planGetResponsePlanTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const planGetResponsePlanTenantPhone4Max = 4;

export const planGetResponsePlanTenantPhone4RegExp = new RegExp('^\\d*$');
export const planGetResponsePlanTenantPhone5Max = 4;

export const planGetResponsePlanTenantPhone5RegExp = new RegExp('^\\d*$');
export const planGetResponsePlanTenantPhone6Max = 4;

export const planGetResponsePlanTenantPhone6RegExp = new RegExp('^\\d*$');
export const planGetResponsePlanTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planGetResponsePlanTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planGetResponsePlanTenantOccupantsItemPhoneMax = 20;
export const planGetResponsePlanTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planGetResponsePlanTenantOccupantsItemNoteMax = 1000;


export const planGetResponse = zod.object({
  "plan": zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(planGetResponsePlanStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(planGetResponsePlanEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(planGetResponsePlanRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(planGetResponsePlanRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(planGetResponsePlanRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(planGetResponsePlanRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(planGetResponsePlanRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(planGetResponsePlanRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(planGetResponsePlanTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(planGetResponsePlanTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(planGetResponsePlanTenantPhone1Max).regex(planGetResponsePlanTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(planGetResponsePlanTenantPhone2Max).regex(planGetResponsePlanTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(planGetResponsePlanTenantPhone3Max).regex(planGetResponsePlanTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(planGetResponsePlanTenantPhone4Max).regex(planGetResponsePlanTenantPhone4RegExp),
  "phone5": zod.string().max(planGetResponsePlanTenantPhone5Max).regex(planGetResponsePlanTenantPhone5RegExp),
  "phone6": zod.string().max(planGetResponsePlanTenantPhone6Max).regex(planGetResponsePlanTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(planGetResponsePlanTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(planGetResponsePlanTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(planGetResponsePlanTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(planGetResponsePlanTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(planGetResponsePlanTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})
})


/**
 * @summary planDelete
 */
export const planDeleteParams = zod.object({
  "id": zod.string()
})


/**
 * @summary planCreate
 */
export const planCreateBodyStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');


export const planCreateBody = zod.object({
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "startDate": zod.string().regex(planCreateBodyStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）')
})


/**
 * @summary planCancel
 */
export const planCancelParams = zod.object({
  "id": zod.string()
})

export const planCancelBodyEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const planCancelBodyContractEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');


export const planCancelBody = zod.object({
  "endDate": zod.string().regex(planCancelBodyEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullish().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "contractEndDate": zod.string().regex(planCancelBodyContractEndDateRegExp).nullish().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中')
})


/**
 * @summary planRevival
 */
export const planRevivalParams = zod.object({
  "id": zod.string()
})


/**
 * @summary propertyGet
 */
export const propertyGetParams = zod.object({
  "id": zod.string()
})

export const propertyGetQueryParams = zod.object({
  "withOwner": zod.enum(['true', 'false']).optional(),
  "withRooms": zod.enum(['true', 'false']).optional(),
  "withRoomsTenants": zod.enum(['true', 'false']).optional(),
  "withRoomsTenantsFiles": zod.enum(['true', 'false']).optional(),
  "withRoomsPlans": zod.enum(['true', 'false']).optional(),
  "withRoomsOwnerMemos": zod.enum(['true', 'false']).optional(),
  "withRoomsOwnerMemosFiles": zod.enum(['true', 'false']).optional()
})

export const propertyGetResponsePropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyGetResponsePropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyGetResponsePropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyGetResponsePropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyGetResponsePropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const propertyGetResponsePropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const propertyGetResponse = zod.object({
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(propertyGetResponsePropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(propertyGetResponsePropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(propertyGetResponsePropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(propertyGetResponsePropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(propertyGetResponsePropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(propertyGetResponsePropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.any().nullish().describe('部屋が属する物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})
})


/**
 * @summary propertyUpdate
 */
export const propertyUpdateParams = zod.object({
  "id": zod.string()
})

export const propertyUpdateBodyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyUpdateBodyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyUpdateBodyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyUpdateBodyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const propertyUpdateBodyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const propertyUpdateBody = zod.object({
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).describe('物件名'),
  "nameKana": zod.string().min(1).regex(propertyUpdateBodyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(propertyUpdateBodyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(propertyUpdateBodyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(propertyUpdateBodyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(propertyUpdateBodyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考')
})


/**
 * @summary propertyList
 */
export const propertyListQueryPageDefault = 1;export const propertyListQueryLimitDefault = 20;export const propertyListQuerySortByDefault = "id";export const propertyListQuerySortOrderDefault = "desc";

export const propertyListQueryParams = zod.object({
  "page": zod.number().default(propertyListQueryPageDefault),
  "limit": zod.number().default(propertyListQueryLimitDefault),
  "propertyId": zod.number().nullish().describe('指定したIDに一致する物件のみ'),
  "propertyName": zod.string().optional().describe('物件名の部分一致'),
  "propertyNameKana": zod.string().optional().describe('物件名（カナ）の部分一致'),
  "postalCode": zod.string().optional().describe('郵便番号の部分一致'),
  "address": zod.string().optional().describe('都道府県以下の住所で部分一致'),
  "ownerId": zod.string().optional().describe('オーナーIDの完全一致'),
  "ownerName": zod.string().optional().describe('オーナー名の部分一致'),
  "managementCompany": zod.string().optional().describe('建物管理会社名の部分一致'),
  "isEchoesLinked": zod.enum(['true', 'false']).optional().describe('true: Echoes 連携済み物件のみ / false: 未連携物件のみ'),
  "sortBy": zod.enum(['id', 'name']).default(propertyListQuerySortByDefault).describe('並び替え項目'),
  "sortOrder": zod.enum(['asc', 'desc']).default(propertyListQuerySortOrderDefault).describe('並び替え順'),
  "withOwner": zod.enum(['true', 'false']).optional(),
  "withRooms": zod.enum(['true', 'false']).optional(),
  "withRoomsTenants": zod.enum(['true', 'false']).optional(),
  "withRoomsTenantsFiles": zod.enum(['true', 'false']).optional(),
  "withRoomsPlans": zod.enum(['true', 'false']).optional(),
  "withRoomsOwnerMemos": zod.enum(['true', 'false']).optional(),
  "withRoomsOwnerMemosFiles": zod.enum(['true', 'false']).optional()
})

export const propertyListResponsePropertiesItemNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyListResponsePropertiesItemNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyListResponsePropertiesItemPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyListResponsePropertiesItemCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyListResponsePropertiesItemTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const propertyListResponsePropertiesItemDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const propertyListResponse = zod.object({
  "total": zod.number(),
  "properties": zod.array(zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(propertyListResponsePropertiesItemNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(propertyListResponsePropertiesItemNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(propertyListResponsePropertiesItemPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(propertyListResponsePropertiesItemCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(propertyListResponsePropertiesItemTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(propertyListResponsePropertiesItemDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.any().nullish().describe('部屋が属する物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}))
})


/**
 * @summary propertyCreate
 */
export const propertyCreateBodyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyCreateBodyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyCreateBodyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const propertyCreateBodyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const propertyCreateBodyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const propertyCreateBody = zod.object({
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).describe('物件名'),
  "nameKana": zod.string().min(1).regex(propertyCreateBodyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(propertyCreateBodyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(propertyCreateBodyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(propertyCreateBodyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(propertyCreateBodyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考')
})


/**
 * @summary propertyUpdateAdminMemo
 */
export const propertyUpdateAdminMemoParams = zod.object({
  "id": zod.string()
})

export const propertyUpdateAdminMemoBody = zod.object({
  "adminMemo": zod.string().describe('管理者用メモ（社内用）')
})


/**
 * @summary roleList
 */
export const roleListResponseRolesItemRoleMax = 255;

export const roleListResponseRolesItemRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const roleListResponseRolesItemLabelMax = 255;


export const roleListResponse = zod.object({
  "roles": zod.array(zod.object({
  "role": zod.string().min(1).max(roleListResponseRolesItemRoleMax).regex(roleListResponseRolesItemRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "label": zod.string().min(1).max(roleListResponseRolesItemLabelMax).describe('表示名。予約ロールはコードで固定されている'),
  "organizationId": zod.string().nullable().describe('定義元の組織。予約ロールはどの組織でも使えるため null'),
  "editable": zod.boolean().describe('権限を変更できるか。予約ロールはコードで定義されているため変更できない'),
  "permissions": zod.record(zod.string(), zod.array(zod.enum(['create', 'read', 'update', 'delete']))).describe('リソース名 -> 許可する操作。設定できるのは GET /permissions が返す組み合わせのみ'),
  "organizationName": zod.string().nullish().describe('定義元の組織名（withOrganization 指定時のみ含まれる。予約ロールは null）')
}))
})


/**
 * @summary roleCreate
 */
export const roleCreateBodyRoleMax = 255;

export const roleCreateBodyRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const roleCreateBodyLabelMax = 255;


export const roleCreateBody = zod.object({
  "organizationId": zod.string().describe('ロールを定義する組織'),
  "role": zod.string().min(1).max(roleCreateBodyRoleMax).regex(roleCreateBodyRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "label": zod.string().min(1).max(roleCreateBodyLabelMax).describe('ロールの表示名。画面に出るのはこちらでロール名ではない'),
  "permissions": zod.record(zod.string(), zod.array(zod.enum(['create', 'read', 'update', 'delete']))).describe('リソース名 -> 許可する操作。設定できるのは GET /permissions が返す組み合わせのみ')
})


/**
 * @summary roleUpdate
 */
export const roleUpdatePathRoleMax = 255;

export const roleUpdatePathRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const roleUpdateParams = zod.object({
  "organizationId": zod.string().describe('ロールを定義する組織'),
  "role": zod.string().min(1).max(roleUpdatePathRoleMax).regex(roleUpdatePathRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)')
})

export const roleUpdateBodyLabelMax = 255;


export const roleUpdateBody = zod.object({
  "label": zod.string().min(1).max(roleUpdateBodyLabelMax).describe('ロールの表示名。画面に出るのはこちらでロール名ではない'),
  "permissions": zod.record(zod.string(), zod.array(zod.enum(['create', 'read', 'update', 'delete']))).describe('リソース名 -> 許可する操作。設定できるのは GET /permissions が返す組み合わせのみ')
})


/**
 * @summary roleDelete
 */
export const roleDeletePathRoleMax = 255;

export const roleDeletePathRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const roleDeleteParams = zod.object({
  "organizationId": zod.string().describe('ロールを定義する組織'),
  "role": zod.string().min(1).max(roleDeletePathRoleMax).regex(roleDeletePathRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)')
})


/**
 * @summary roomGet
 */
export const roomGetParams = zod.object({
  "id": zod.string()
})

export const roomGetQueryParams = zod.object({
  "withProperty": zod.enum(['true', 'false']).optional(),
  "withPropertyOwner": zod.enum(['true', 'false']).optional(),
  "withTenants": zod.enum(['true', 'false']).optional(),
  "withTenantsFiles": zod.enum(['true', 'false']).optional(),
  "withTenantsOccupants": zod.enum(['true', 'false']).optional(),
  "withPlans": zod.enum(['true', 'false']).optional(),
  "withOwnerMemos": zod.enum(['true', 'false']).optional(),
  "withOwnerMemosFiles": zod.enum(['true', 'false']).optional()
})

export const roomGetResponseRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomGetResponseRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomGetResponseRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomGetResponseRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomGetResponseRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const roomGetResponseRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const roomGetResponseRoomTenantsItemNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomGetResponseRoomTenantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomGetResponseRoomTenantsItemPhone1Max = 4;

export const roomGetResponseRoomTenantsItemPhone1RegExp = new RegExp('^\\d{1,4}$');
export const roomGetResponseRoomTenantsItemPhone2Max = 4;

export const roomGetResponseRoomTenantsItemPhone2RegExp = new RegExp('^\\d{1,4}$');
export const roomGetResponseRoomTenantsItemPhone3Max = 4;

export const roomGetResponseRoomTenantsItemPhone3RegExp = new RegExp('^\\d{1,4}$');
export const roomGetResponseRoomTenantsItemPhone4Max = 4;

export const roomGetResponseRoomTenantsItemPhone4RegExp = new RegExp('^\\d*$');
export const roomGetResponseRoomTenantsItemPhone5Max = 4;

export const roomGetResponseRoomTenantsItemPhone5RegExp = new RegExp('^\\d*$');
export const roomGetResponseRoomTenantsItemPhone6Max = 4;

export const roomGetResponseRoomTenantsItemPhone6RegExp = new RegExp('^\\d*$');
export const roomGetResponseRoomTenantsItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomGetResponseRoomTenantsItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomGetResponseRoomTenantsItemOccupantsItemPhoneMax = 20;
export const roomGetResponseRoomTenantsItemOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomGetResponseRoomTenantsItemOccupantsItemNoteMax = 1000;
export const roomGetResponseRoomPlansItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomGetResponseRoomPlansItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');


export const roomGetResponse = zod.object({
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(roomGetResponseRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(roomGetResponseRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(roomGetResponseRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(roomGetResponseRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(roomGetResponseRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(roomGetResponseRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(roomGetResponseRoomTenantsItemNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(roomGetResponseRoomTenantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(roomGetResponseRoomTenantsItemPhone1Max).regex(roomGetResponseRoomTenantsItemPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(roomGetResponseRoomTenantsItemPhone2Max).regex(roomGetResponseRoomTenantsItemPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(roomGetResponseRoomTenantsItemPhone3Max).regex(roomGetResponseRoomTenantsItemPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(roomGetResponseRoomTenantsItemPhone4Max).regex(roomGetResponseRoomTenantsItemPhone4RegExp),
  "phone5": zod.string().max(roomGetResponseRoomTenantsItemPhone5Max).regex(roomGetResponseRoomTenantsItemPhone5RegExp),
  "phone6": zod.string().max(roomGetResponseRoomTenantsItemPhone6Max).regex(roomGetResponseRoomTenantsItemPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(roomGetResponseRoomTenantsItemStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(roomGetResponseRoomTenantsItemEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(roomGetResponseRoomTenantsItemOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(roomGetResponseRoomTenantsItemOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(roomGetResponseRoomTenantsItemOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "plans": zod.array(zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(roomGetResponseRoomPlansItemStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(roomGetResponseRoomPlansItemEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional().describe('契約中のプランマスタ情報（取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('契約対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "tenant": zod.any().nullish().describe('契約対象の賃借人情報（TenantResponse 相当。取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})
})


/**
 * @summary roomUpdate
 */
export const roomUpdateParams = zod.object({
  "id": zod.string()
})

export const roomUpdateBody = zod.object({
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階')
})


/**
 * @summary roomDelete
 */
export const roomDeleteParams = zod.object({
  "id": zod.string()
})


/**
 * @summary roomList
 */
export const roomListQueryPageDefault = 1;export const roomListQueryLimitDefault = 20;

export const roomListQueryParams = zod.object({
  "page": zod.number().default(roomListQueryPageDefault),
  "limit": zod.number().default(roomListQueryLimitDefault),
  "propertyId": zod.number().nullish(),
  "nameLike": zod.string().optional(),
  "propertyNameLike": zod.string().optional(),
  "propertyAddressLike": zod.string().optional(),
  "tenantNameLike": zod.string().optional(),
  "tenantPhoneLike": zod.string().optional(),
  "ownerNameLike": zod.string().optional(),
  "withProperty": zod.enum(['true', 'false']).optional(),
  "withPropertyOwner": zod.enum(['true', 'false']).optional(),
  "withTenants": zod.enum(['true', 'false']).optional(),
  "withTenantsFiles": zod.enum(['true', 'false']).optional(),
  "withTenantsOccupants": zod.enum(['true', 'false']).optional(),
  "withPlans": zod.enum(['true', 'false']).optional(),
  "withOwnerMemos": zod.enum(['true', 'false']).optional(),
  "withOwnerMemosFiles": zod.enum(['true', 'false']).optional()
})

export const roomListResponseRoomsItemPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomListResponseRoomsItemPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomListResponseRoomsItemPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomListResponseRoomsItemPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomListResponseRoomsItemPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const roomListResponseRoomsItemPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const roomListResponseRoomsItemTenantsItemNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const roomListResponseRoomsItemTenantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomListResponseRoomsItemTenantsItemPhone1Max = 4;

export const roomListResponseRoomsItemTenantsItemPhone1RegExp = new RegExp('^\\d{1,4}$');
export const roomListResponseRoomsItemTenantsItemPhone2Max = 4;

export const roomListResponseRoomsItemTenantsItemPhone2RegExp = new RegExp('^\\d{1,4}$');
export const roomListResponseRoomsItemTenantsItemPhone3Max = 4;

export const roomListResponseRoomsItemTenantsItemPhone3RegExp = new RegExp('^\\d{1,4}$');
export const roomListResponseRoomsItemTenantsItemPhone4Max = 4;

export const roomListResponseRoomsItemTenantsItemPhone4RegExp = new RegExp('^\\d*$');
export const roomListResponseRoomsItemTenantsItemPhone5Max = 4;

export const roomListResponseRoomsItemTenantsItemPhone5RegExp = new RegExp('^\\d*$');
export const roomListResponseRoomsItemTenantsItemPhone6Max = 4;

export const roomListResponseRoomsItemTenantsItemPhone6RegExp = new RegExp('^\\d*$');
export const roomListResponseRoomsItemTenantsItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomListResponseRoomsItemTenantsItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomListResponseRoomsItemTenantsItemOccupantsItemPhoneMax = 20;
export const roomListResponseRoomsItemTenantsItemOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomListResponseRoomsItemTenantsItemOccupantsItemNoteMax = 1000;
export const roomListResponseRoomsItemPlansItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const roomListResponseRoomsItemPlansItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');


export const roomListResponse = zod.object({
  "total": zod.number(),
  "rooms": zod.array(zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(roomListResponseRoomsItemPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(roomListResponseRoomsItemPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(roomListResponseRoomsItemPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(roomListResponseRoomsItemPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(roomListResponseRoomsItemPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(roomListResponseRoomsItemPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(roomListResponseRoomsItemTenantsItemNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(roomListResponseRoomsItemTenantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(roomListResponseRoomsItemTenantsItemPhone1Max).regex(roomListResponseRoomsItemTenantsItemPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(roomListResponseRoomsItemTenantsItemPhone2Max).regex(roomListResponseRoomsItemTenantsItemPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(roomListResponseRoomsItemTenantsItemPhone3Max).regex(roomListResponseRoomsItemTenantsItemPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(roomListResponseRoomsItemTenantsItemPhone4Max).regex(roomListResponseRoomsItemTenantsItemPhone4RegExp),
  "phone5": zod.string().max(roomListResponseRoomsItemTenantsItemPhone5Max).regex(roomListResponseRoomsItemTenantsItemPhone5RegExp),
  "phone6": zod.string().max(roomListResponseRoomsItemTenantsItemPhone6Max).regex(roomListResponseRoomsItemTenantsItemPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(roomListResponseRoomsItemTenantsItemStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(roomListResponseRoomsItemTenantsItemEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(roomListResponseRoomsItemTenantsItemOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(roomListResponseRoomsItemTenantsItemOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(roomListResponseRoomsItemTenantsItemOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "plans": zod.array(zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(roomListResponseRoomsItemPlansItemStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(roomListResponseRoomsItemPlansItemEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional().describe('契約中のプランマスタ情報（取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('契約対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "tenant": zod.any().nullish().describe('契約対象の賃借人情報（TenantResponse 相当。取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}))
})


/**
 * @summary roomCreate
 */
export const roomCreateBody = zod.object({
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階')
})


/**
 * @summary roomUpdateAdminMemo
 */
export const roomUpdateAdminMemoParams = zod.object({
  "id": zod.string()
})

export const roomUpdateAdminMemoBody = zod.object({
  "adminMemo": zod.string().describe('管理者用メモ（社内用）')
})


/**
 * @summary tenantApplicationList
 */
export const tenantApplicationListQueryPageDefault = 1;export const tenantApplicationListQueryLimitDefault = 10;export const tenantApplicationListQueryStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');


export const tenantApplicationListQueryParams = zod.object({
  "page": zod.number().default(tenantApplicationListQueryPageDefault),
  "limit": zod.number().default(tenantApplicationListQueryLimitDefault),
  "id": zod.number().nullish(),
  "approvalStatus": zod.enum(['pending', 'approved', 'rejected']).optional(),
  "nameLike": zod.string().optional(),
  "nameKanaLike": zod.string().optional(),
  "propertyNameLike": zod.string().optional(),
  "roomNameLike": zod.string().optional(),
  "ownerNameLike": zod.string().optional(),
  "startDate": zod.string().regex(tenantApplicationListQueryStartDateRegExp).optional(),
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withRoomProperty": zod.enum(['true', 'false']).optional(),
  "withRoomPropertyOwner": zod.enum(['true', 'false']).optional(),
  "withFiles": zod.enum(['true', 'false']).optional()
})

export const tenantApplicationListResponseTenantApplicationsItemPhone1Max = 4;

export const tenantApplicationListResponseTenantApplicationsItemPhone1RegExp = new RegExp('^\\d{1,4}$');
export const tenantApplicationListResponseTenantApplicationsItemPhone2Max = 4;

export const tenantApplicationListResponseTenantApplicationsItemPhone2RegExp = new RegExp('^\\d{1,4}$');
export const tenantApplicationListResponseTenantApplicationsItemPhone3Max = 4;

export const tenantApplicationListResponseTenantApplicationsItemPhone3RegExp = new RegExp('^\\d{1,4}$');
export const tenantApplicationListResponseTenantApplicationsItemPhone4Max = 4;

export const tenantApplicationListResponseTenantApplicationsItemPhone4RegExp = new RegExp('^\\d{0,4}$');
export const tenantApplicationListResponseTenantApplicationsItemPhone5Max = 4;

export const tenantApplicationListResponseTenantApplicationsItemPhone5RegExp = new RegExp('^\\d{0,4}$');
export const tenantApplicationListResponseTenantApplicationsItemPhone6Max = 4;

export const tenantApplicationListResponseTenantApplicationsItemPhone6RegExp = new RegExp('^\\d{0,4}$');
export const tenantApplicationListResponseTenantApplicationsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantApplicationListResponseTenantApplicationsItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantApplicationListResponseTenantApplicationsItemOccupantsItemPhoneMax = 20;
export const tenantApplicationListResponseTenantApplicationsItemOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantApplicationListResponseTenantApplicationsItemOccupantsItemNoteMax = 1000;
export const tenantApplicationListResponseTenantApplicationsItemRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationListResponseTenantApplicationsItemRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationListResponseTenantApplicationsItemRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationListResponseTenantApplicationsItemRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationListResponseTenantApplicationsItemRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const tenantApplicationListResponseTenantApplicationsItemRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const tenantApplicationListResponse = zod.object({
  "total": zod.number(),
  "tenantApplications": zod.array(zod.object({
  "id": zod.number().describe('入居申込ID'),
  "roomId": zod.number().describe('申込対象の部屋ID'),
  "name": zod.string().describe('申込者の氏名'),
  "nameKana": zod.string().describe('申込者の氏名カナ'),
  "phone1": zod.string().min(1).max(tenantApplicationListResponseTenantApplicationsItemPhone1Max).regex(tenantApplicationListResponseTenantApplicationsItemPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(tenantApplicationListResponseTenantApplicationsItemPhone2Max).regex(tenantApplicationListResponseTenantApplicationsItemPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(tenantApplicationListResponseTenantApplicationsItemPhone3Max).regex(tenantApplicationListResponseTenantApplicationsItemPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(tenantApplicationListResponseTenantApplicationsItemPhone4Max).regex(tenantApplicationListResponseTenantApplicationsItemPhone4RegExp).describe('電話番号2の市外局番'),
  "phone5": zod.string().max(tenantApplicationListResponseTenantApplicationsItemPhone5Max).regex(tenantApplicationListResponseTenantApplicationsItemPhone5RegExp).describe('電話番号2の市内局番'),
  "phone6": zod.string().max(tenantApplicationListResponseTenantApplicationsItemPhone6Max).regex(tenantApplicationListResponseTenantApplicationsItemPhone6RegExp).describe('電話番号2の加入者番号'),
  "email": zod.string().describe('申込者のメールアドレス'),
  "birthday": zod.string().regex(tenantApplicationListResponseTenantApplicationsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "contractType": zod.enum(['individual', 'corporation']).describe('契約区分（individual:個人 / corporation:法人）'),
  "startDate": zod.string().regex(tenantApplicationListResponseTenantApplicationsItemStartDateRegExp).describe('賃貸借契約の開始予定日（YYYY-MM-DD）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "occupants": zod.array(zod.object({
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(tenantApplicationListResponseTenantApplicationsItemOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(tenantApplicationListResponseTenantApplicationsItemOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(tenantApplicationListResponseTenantApplicationsItemOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullish().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('入居者の一覧。指定した内容で全置換する（省略時は変更しない、空配列で全削除）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "agencyName": zod.string().describe('仲介会社名'),
  "agencyPhone": zod.string().describe('仲介会社の電話番号'),
  "otherContact": zod.string().describe('その他の連絡先'),
  "submittedAt": zod.string().nullable().describe('申込内容が送信された日時（ISO8601）。null は未送信'),
  "approvalStatus": zod.enum(['pending', 'approved', 'rejected']).describe('オーナーの承認状況（pending:未承認 / approved:承認済み / rejected:却下）'),
  "ownerRespondedAt": zod.string().nullable().describe('オーナーが承認・却下を回答した日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(tenantApplicationListResponseTenantApplicationsItemRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(tenantApplicationListResponseTenantApplicationsItemRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(tenantApplicationListResponseTenantApplicationsItemRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(tenantApplicationListResponseTenantApplicationsItemRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(tenantApplicationListResponseTenantApplicationsItemRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(tenantApplicationListResponseTenantApplicationsItemRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional()
}))
})


/**
 * @summary tenantApplicationGet
 */
export const tenantApplicationGetParams = zod.object({
  "id": zod.string()
})

export const tenantApplicationGetQueryParams = zod.object({
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withRoomProperty": zod.enum(['true', 'false']).optional(),
  "withRoomPropertyOwner": zod.enum(['true', 'false']).optional(),
  "withFiles": zod.enum(['true', 'false']).optional()
})

export const tenantApplicationGetResponseTenantApplicationPhone1Max = 4;

export const tenantApplicationGetResponseTenantApplicationPhone1RegExp = new RegExp('^\\d{1,4}$');
export const tenantApplicationGetResponseTenantApplicationPhone2Max = 4;

export const tenantApplicationGetResponseTenantApplicationPhone2RegExp = new RegExp('^\\d{1,4}$');
export const tenantApplicationGetResponseTenantApplicationPhone3Max = 4;

export const tenantApplicationGetResponseTenantApplicationPhone3RegExp = new RegExp('^\\d{1,4}$');
export const tenantApplicationGetResponseTenantApplicationPhone4Max = 4;

export const tenantApplicationGetResponseTenantApplicationPhone4RegExp = new RegExp('^\\d{0,4}$');
export const tenantApplicationGetResponseTenantApplicationPhone5Max = 4;

export const tenantApplicationGetResponseTenantApplicationPhone5RegExp = new RegExp('^\\d{0,4}$');
export const tenantApplicationGetResponseTenantApplicationPhone6Max = 4;

export const tenantApplicationGetResponseTenantApplicationPhone6RegExp = new RegExp('^\\d{0,4}$');
export const tenantApplicationGetResponseTenantApplicationBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantApplicationGetResponseTenantApplicationStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantApplicationGetResponseTenantApplicationOccupantsItemPhoneMax = 20;
export const tenantApplicationGetResponseTenantApplicationOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantApplicationGetResponseTenantApplicationOccupantsItemNoteMax = 1000;
export const tenantApplicationGetResponseTenantApplicationRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationGetResponseTenantApplicationRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationGetResponseTenantApplicationRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationGetResponseTenantApplicationRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantApplicationGetResponseTenantApplicationRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const tenantApplicationGetResponseTenantApplicationRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');


export const tenantApplicationGetResponse = zod.object({
  "tenantApplication": zod.object({
  "id": zod.number().describe('入居申込ID'),
  "roomId": zod.number().describe('申込対象の部屋ID'),
  "name": zod.string().describe('申込者の氏名'),
  "nameKana": zod.string().describe('申込者の氏名カナ'),
  "phone1": zod.string().min(1).max(tenantApplicationGetResponseTenantApplicationPhone1Max).regex(tenantApplicationGetResponseTenantApplicationPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(tenantApplicationGetResponseTenantApplicationPhone2Max).regex(tenantApplicationGetResponseTenantApplicationPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(tenantApplicationGetResponseTenantApplicationPhone3Max).regex(tenantApplicationGetResponseTenantApplicationPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(tenantApplicationGetResponseTenantApplicationPhone4Max).regex(tenantApplicationGetResponseTenantApplicationPhone4RegExp).describe('電話番号2の市外局番'),
  "phone5": zod.string().max(tenantApplicationGetResponseTenantApplicationPhone5Max).regex(tenantApplicationGetResponseTenantApplicationPhone5RegExp).describe('電話番号2の市内局番'),
  "phone6": zod.string().max(tenantApplicationGetResponseTenantApplicationPhone6Max).regex(tenantApplicationGetResponseTenantApplicationPhone6RegExp).describe('電話番号2の加入者番号'),
  "email": zod.string().describe('申込者のメールアドレス'),
  "birthday": zod.string().regex(tenantApplicationGetResponseTenantApplicationBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "contractType": zod.enum(['individual', 'corporation']).describe('契約区分（individual:個人 / corporation:法人）'),
  "startDate": zod.string().regex(tenantApplicationGetResponseTenantApplicationStartDateRegExp).describe('賃貸借契約の開始予定日（YYYY-MM-DD）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "occupants": zod.array(zod.object({
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(tenantApplicationGetResponseTenantApplicationOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(tenantApplicationGetResponseTenantApplicationOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(tenantApplicationGetResponseTenantApplicationOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullish().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('入居者の一覧。指定した内容で全置換する（省略時は変更しない、空配列で全削除）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "agencyName": zod.string().describe('仲介会社名'),
  "agencyPhone": zod.string().describe('仲介会社の電話番号'),
  "otherContact": zod.string().describe('その他の連絡先'),
  "submittedAt": zod.string().nullable().describe('申込内容が送信された日時（ISO8601）。null は未送信'),
  "approvalStatus": zod.enum(['pending', 'approved', 'rejected']).describe('オーナーの承認状況（pending:未承認 / approved:承認済み / rejected:却下）'),
  "ownerRespondedAt": zod.string().nullable().describe('オーナーが承認・却下を回答した日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(tenantApplicationGetResponseTenantApplicationRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(tenantApplicationGetResponseTenantApplicationRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(tenantApplicationGetResponseTenantApplicationRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(tenantApplicationGetResponseTenantApplicationRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(tenantApplicationGetResponseTenantApplicationRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(tenantApplicationGetResponseTenantApplicationRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional()
})
})


/**
 * @summary tenantGet
 */
export const tenantGetParams = zod.object({
  "id": zod.string()
})

export const tenantGetQueryParams = zod.object({
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withRoomProperty": zod.enum(['true', 'false']).optional(),
  "withRoomPropertyOwner": zod.enum(['true', 'false']).optional(),
  "withRoomPlans": zod.enum(['true', 'false']).optional(),
  "withPlans": zod.enum(['true', 'false']).optional(),
  "withFiles": zod.enum(['true', 'false']).optional(),
  "withOccupants": zod.enum(['true', 'false']).optional()
})

export const tenantGetResponseTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantGetResponseTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantPhone1Max = 4;

export const tenantGetResponseTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const tenantGetResponseTenantPhone2Max = 4;

export const tenantGetResponseTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const tenantGetResponseTenantPhone3Max = 4;

export const tenantGetResponseTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const tenantGetResponseTenantPhone4Max = 4;

export const tenantGetResponseTenantPhone4RegExp = new RegExp('^\\d*$');
export const tenantGetResponseTenantPhone5Max = 4;

export const tenantGetResponseTenantPhone5RegExp = new RegExp('^\\d*$');
export const tenantGetResponseTenantPhone6Max = 4;

export const tenantGetResponseTenantPhone6RegExp = new RegExp('^\\d*$');
export const tenantGetResponseTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantGetResponseTenantRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantGetResponseTenantRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantGetResponseTenantRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantGetResponseTenantRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const tenantGetResponseTenantRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const tenantGetResponseTenantRoomPlansItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantRoomPlansItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantPlansItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantPlansItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantOccupantsItemPhoneMax = 20;
export const tenantGetResponseTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantGetResponseTenantOccupantsItemNoteMax = 1000;


export const tenantGetResponse = zod.object({
  "tenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(tenantGetResponseTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(tenantGetResponseTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(tenantGetResponseTenantPhone1Max).regex(tenantGetResponseTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(tenantGetResponseTenantPhone2Max).regex(tenantGetResponseTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(tenantGetResponseTenantPhone3Max).regex(tenantGetResponseTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(tenantGetResponseTenantPhone4Max).regex(tenantGetResponseTenantPhone4RegExp),
  "phone5": zod.string().max(tenantGetResponseTenantPhone5Max).regex(tenantGetResponseTenantPhone5RegExp),
  "phone6": zod.string().max(tenantGetResponseTenantPhone6Max).regex(tenantGetResponseTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(tenantGetResponseTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(tenantGetResponseTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(tenantGetResponseTenantRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(tenantGetResponseTenantRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(tenantGetResponseTenantRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(tenantGetResponseTenantRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(tenantGetResponseTenantRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(tenantGetResponseTenantRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(tenantGetResponseTenantRoomPlansItemStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(tenantGetResponseTenantRoomPlansItemEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional().describe('契約中のプランマスタ情報（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "plans": zod.array(zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(tenantGetResponseTenantPlansItemStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(tenantGetResponseTenantPlansItemEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional().describe('契約中のプランマスタ情報（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(tenantGetResponseTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(tenantGetResponseTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(tenantGetResponseTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})
})


/**
 * @summary tenantUpdate
 */
export const tenantUpdateParams = zod.object({
  "id": zod.string()
})

export const tenantUpdateBodyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantUpdateBodyPhone1Max = 4;

export const tenantUpdateBodyPhone1RegExp = new RegExp('^\\d{1,4}$');
export const tenantUpdateBodyPhone2Max = 4;

export const tenantUpdateBodyPhone2RegExp = new RegExp('^\\d{1,4}$');
export const tenantUpdateBodyPhone3Max = 4;

export const tenantUpdateBodyPhone3RegExp = new RegExp('^\\d{1,4}$');
export const tenantUpdateBodyPhone4Default = "";
export const tenantUpdateBodyPhone4Max = 4;

export const tenantUpdateBodyPhone4RegExp = new RegExp('^\\d*$');
export const tenantUpdateBodyPhone5Default = "";
export const tenantUpdateBodyPhone5Max = 4;

export const tenantUpdateBodyPhone5RegExp = new RegExp('^\\d*$');
export const tenantUpdateBodyPhone6Default = "";
export const tenantUpdateBodyPhone6Max = 4;

export const tenantUpdateBodyPhone6RegExp = new RegExp('^\\d*$');
export const tenantUpdateBodyBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantUpdateBodyStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantUpdateBodyOccupantsItemPhoneMax = 20;
export const tenantUpdateBodyOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantUpdateBodyOccupantsItemNoteMax = 1000;


export const tenantUpdateBody = zod.object({
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(tenantUpdateBodyNameKanaRegExp).describe('賃借人の氏名カナ'),
  "phone1": zod.string().min(1).max(tenantUpdateBodyPhone1Max).regex(tenantUpdateBodyPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(tenantUpdateBodyPhone2Max).regex(tenantUpdateBodyPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(tenantUpdateBodyPhone3Max).regex(tenantUpdateBodyPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(tenantUpdateBodyPhone4Max).regex(tenantUpdateBodyPhone4RegExp).optional(),
  "phone5": zod.string().max(tenantUpdateBodyPhone5Max).regex(tenantUpdateBodyPhone5RegExp).optional(),
  "phone6": zod.string().max(tenantUpdateBodyPhone6Max).regex(tenantUpdateBodyPhone6RegExp).optional(),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "birthday": zod.string().regex(tenantUpdateBodyBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "startDate": zod.string().regex(tenantUpdateBodyStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "occupants": zod.array(zod.object({
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(tenantUpdateBodyOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(tenantUpdateBodyOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(tenantUpdateBodyOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullish().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('入居者の一覧。指定した内容で全置換する（省略時は変更しない、空配列で全削除）')
})


/**
 * @summary tenantDelete
 */
export const tenantDeleteParams = zod.object({
  "id": zod.string()
})


/**
 * @summary tenantList
 */
export const tenantListQueryPageDefault = 1;export const tenantListQueryLimitDefault = 10;

export const tenantListQueryParams = zod.object({
  "page": zod.number().default(tenantListQueryPageDefault),
  "limit": zod.number().default(tenantListQueryLimitDefault),
  "id": zod.number().nullish(),
  "nameLike": zod.string().optional(),
  "nameKanaLike": zod.string().optional(),
  "propertyNameLike": zod.string().optional(),
  "roomNameLike": zod.string().optional(),
  "propertyAddressLike": zod.string().optional(),
  "phoneLike": zod.string().optional(),
  "ownerNameLike": zod.string().optional(),
  "startDateFrom": zod.string().optional(),
  "startDateTo": zod.string().optional(),
  "endDateFrom": zod.string().optional(),
  "endDateTo": zod.string().optional(),
  "isEchoesLinked": zod.enum(['true', 'false']).optional().describe('true: Echoes 連携済み賃借人のみ / false: 未連携賃借人のみ'),
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withRoomProperty": zod.enum(['true', 'false']).optional(),
  "withRoomPropertyOwner": zod.enum(['true', 'false']).optional(),
  "withRoomPlans": zod.enum(['true', 'false']).optional(),
  "withPlans": zod.enum(['true', 'false']).optional(),
  "withFiles": zod.enum(['true', 'false']).optional(),
  "withOccupants": zod.enum(['true', 'false']).optional()
})

export const tenantListResponseTenantsItemNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantListResponseTenantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemPhone1Max = 4;

export const tenantListResponseTenantsItemPhone1RegExp = new RegExp('^\\d{1,4}$');
export const tenantListResponseTenantsItemPhone2Max = 4;

export const tenantListResponseTenantsItemPhone2RegExp = new RegExp('^\\d{1,4}$');
export const tenantListResponseTenantsItemPhone3Max = 4;

export const tenantListResponseTenantsItemPhone3RegExp = new RegExp('^\\d{1,4}$');
export const tenantListResponseTenantsItemPhone4Max = 4;

export const tenantListResponseTenantsItemPhone4RegExp = new RegExp('^\\d*$');
export const tenantListResponseTenantsItemPhone5Max = 4;

export const tenantListResponseTenantsItemPhone5RegExp = new RegExp('^\\d*$');
export const tenantListResponseTenantsItemPhone6Max = 4;

export const tenantListResponseTenantsItemPhone6RegExp = new RegExp('^\\d*$');
export const tenantListResponseTenantsItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantListResponseTenantsItemRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantListResponseTenantsItemRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantListResponseTenantsItemRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantListResponseTenantsItemRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const tenantListResponseTenantsItemRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const tenantListResponseTenantsItemRoomPlansItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemRoomPlansItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemPlansItemStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemPlansItemEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemOccupantsItemPhoneMax = 20;
export const tenantListResponseTenantsItemOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantListResponseTenantsItemOccupantsItemNoteMax = 1000;


export const tenantListResponse = zod.object({
  "total": zod.number(),
  "tenants": zod.array(zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(tenantListResponseTenantsItemNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(tenantListResponseTenantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(tenantListResponseTenantsItemPhone1Max).regex(tenantListResponseTenantsItemPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(tenantListResponseTenantsItemPhone2Max).regex(tenantListResponseTenantsItemPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(tenantListResponseTenantsItemPhone3Max).regex(tenantListResponseTenantsItemPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(tenantListResponseTenantsItemPhone4Max).regex(tenantListResponseTenantsItemPhone4RegExp),
  "phone5": zod.string().max(tenantListResponseTenantsItemPhone5Max).regex(tenantListResponseTenantsItemPhone5RegExp),
  "phone6": zod.string().max(tenantListResponseTenantsItemPhone6Max).regex(tenantListResponseTenantsItemPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(tenantListResponseTenantsItemStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(tenantListResponseTenantsItemEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(tenantListResponseTenantsItemRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(tenantListResponseTenantsItemRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(tenantListResponseTenantsItemRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(tenantListResponseTenantsItemRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(tenantListResponseTenantsItemRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(tenantListResponseTenantsItemRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(tenantListResponseTenantsItemRoomPlansItemStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(tenantListResponseTenantsItemRoomPlansItemEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional().describe('契約中のプランマスタ情報（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "plans": zod.array(zod.object({
  "id": zod.number().describe('プランID（プラン契約の識別子）'),
  "planMasterId": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "roomId": zod.number().nullable().describe('契約対象の部屋ID。居室単位の契約時のみ値が入る'),
  "monthlyPrice": zod.number().describe('契約時点の月額料金（円・税抜）'),
  "startDate": zod.string().regex(tenantListResponseTenantsItemPlansItemStartDateRegExp).describe('プラン契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(tenantListResponseTenantsItemPlansItemEndDateRegExp).nullable().describe('プラン契約の終了日（YYYY-MM-DD）。null は継続中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "echoesPlanSuspended": zod.boolean().describe('Echoes 側でプランのサービス提供が停止中か(Echoes 連携プランのみ true になり得る)'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "planMaster": zod.object({
  "_id": zod.enum(['1', '2', '3', '4']).describe('プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）'),
  "name": zod.string().describe('プラン名'),
  "monthlyPrice": zod.number().describe('月額料金（円・税抜）'),
  "description": zod.string().describe('プランの説明文'),
  "isActive": zod.boolean().describe('現在申し込み可能なプランかどうか'),
  "features": zod.array(zod.string()).optional().describe('プランに含まれる機能の一覧'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional().describe('契約中のプランマスタ情報（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(tenantListResponseTenantsItemOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(tenantListResponseTenantsItemOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(tenantListResponseTenantsItemOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}))
})


/**
 * @summary tenantCreate
 */
export const tenantCreateBodyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const tenantCreateBodyPhone1Max = 4;

export const tenantCreateBodyPhone1RegExp = new RegExp('^\\d{1,4}$');
export const tenantCreateBodyPhone2Max = 4;

export const tenantCreateBodyPhone2RegExp = new RegExp('^\\d{1,4}$');
export const tenantCreateBodyPhone3Max = 4;

export const tenantCreateBodyPhone3RegExp = new RegExp('^\\d{1,4}$');
export const tenantCreateBodyPhone4Default = "";
export const tenantCreateBodyPhone4Max = 4;

export const tenantCreateBodyPhone4RegExp = new RegExp('^\\d*$');
export const tenantCreateBodyPhone5Default = "";
export const tenantCreateBodyPhone5Max = 4;

export const tenantCreateBodyPhone5RegExp = new RegExp('^\\d*$');
export const tenantCreateBodyPhone6Default = "";
export const tenantCreateBodyPhone6Max = 4;

export const tenantCreateBodyPhone6RegExp = new RegExp('^\\d*$');
export const tenantCreateBodyBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantCreateBodyStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantCreateBodyOccupantsItemPhoneMax = 20;
export const tenantCreateBodyOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const tenantCreateBodyOccupantsItemNoteMax = 1000;


export const tenantCreateBody = zod.object({
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(tenantCreateBodyNameKanaRegExp).describe('賃借人の氏名カナ'),
  "phone1": zod.string().min(1).max(tenantCreateBodyPhone1Max).regex(tenantCreateBodyPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(tenantCreateBodyPhone2Max).regex(tenantCreateBodyPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(tenantCreateBodyPhone3Max).regex(tenantCreateBodyPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(tenantCreateBodyPhone4Max).regex(tenantCreateBodyPhone4RegExp).optional(),
  "phone5": zod.string().max(tenantCreateBodyPhone5Max).regex(tenantCreateBodyPhone5RegExp).optional(),
  "phone6": zod.string().max(tenantCreateBodyPhone6Max).regex(tenantCreateBodyPhone6RegExp).optional(),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "birthday": zod.string().regex(tenantCreateBodyBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "startDate": zod.string().regex(tenantCreateBodyStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "occupants": zod.array(zod.object({
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(tenantCreateBodyOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(tenantCreateBodyOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(tenantCreateBodyOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullish().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('入居者の一覧。指定した内容で全置換する（省略時は変更しない、空配列で全削除）')
})


/**
 * @summary tenantCancel
 */
export const tenantCancelParams = zod.object({
  "id": zod.string()
})

export const tenantCancelBodyEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');


export const tenantCancelBody = zod.object({
  "endDate": zod.string().regex(tenantCancelBodyEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullish().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）')
})


/**
 * @summary tenantRevival
 */
export const tenantRevivalParams = zod.object({
  "id": zod.string()
})


/**
 * @summary tenantUpdateAdminMemo
 */
export const tenantUpdateAdminMemoParams = zod.object({
  "id": zod.string()
})

export const tenantUpdateAdminMemoBody = zod.object({
  "adminMemo": zod.string().describe('管理者用メモ（社内用）')
})


/**
 * @summary ticketMessageList
 */
export const ticketMessageListParams = zod.object({
  "ticketId": zod.string()
})

export const ticketMessageListQueryParams = zod.object({
  "withAdmin": zod.enum(['true', 'false']).optional(),
  "withOwner": zod.enum(['true', 'false']).optional(),
  "withTicket": zod.enum(['true', 'false']).optional(),
  "withFiles": zod.enum(['true', 'false']).optional(),
  "page": zod.string().optional(),
  "limit": zod.string().optional(),
  "sort": zod.enum(['asc', 'desc']).optional()
})

export const ticketMessageListResponseTicketMessagesItemAdminNameKanaMax = 255;
export const ticketMessageListResponseTicketMessagesItemAdminDepartmentMax = 255;
export const ticketMessageListResponseTicketMessagesItemAdminRoleMax = 255;

export const ticketMessageListResponseTicketMessagesItemAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const ticketMessageListResponse = zod.object({
  "ticketMessages": zod.array(zod.object({
  "id": zod.number().describe('チケットメッセージID'),
  "ticketId": zod.number().describe('紐づくチケットID'),
  "senderType": zod.enum(['owner', 'admin', 'system']).describe('送信者種別'),
  "message": zod.string().describe('メッセージ本文'),
  "readAt": zod.string().nullable().describe('既読日時（ISO8601）。null は未読'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "ownerId": zod.string().nullable().describe('送信者がオーナーの場合のオーナーID'),
  "adminId": zod.string().nullable().describe('送信者が管理者の場合の管理者ID'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "admin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketMessageListResponseTicketMessagesItemAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketMessageListResponseTicketMessagesItemAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketMessageListResponseTicketMessagesItemAdminRoleMax).regex(ticketMessageListResponseTicketMessagesItemAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "ticket": zod.any().nullish().describe('紐づくチケット情報（TicketResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})),
  "total": zod.number()
})


/**
 * @summary ticketMessageCreate
 */
export const ticketMessageCreateParams = zod.object({
  "ticketId": zod.string()
})

export const ticketMessageCreateBody = zod.object({
  "message": zod.string().describe('メッセージ本文'),
  "uploadFile": zod.object({
  "path": zod.string(),
  "fileName": zod.string()
}).optional()
})


/**
 * @summary ticketMessageDelete
 */
export const ticketMessageDeleteParams = zod.object({
  "ticketId": zod.string(),
  "ticketMessageId": zod.string()
})


/**
 * @summary ticketGet
 */
export const ticketGetParams = zod.object({
  "id": zod.string()
})

export const ticketGetQueryParams = zod.object({
  "withOwner": zod.enum(['true', 'false']).optional(),
  "withProperty": zod.enum(['true', 'false']).optional(),
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withRoomPlans": zod.enum(['true', 'false']).optional(),
  "withTenant": zod.enum(['true', 'false']).optional(),
  "withTenantFiles": zod.enum(['true', 'false']).optional(),
  "withOcAssignee": zod.enum(['true', 'false']).optional(),
  "withTicketComments": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactFromOwner": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactFromTenant": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactFromAdmin": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactToOwner": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactToTenant": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactToAdmin": zod.enum(['true', 'false']).optional(),
  "withTicketMessages": zod.enum(['true', 'false']).optional(),
  "withTicketMessagesFiles": zod.enum(['true', 'false']).optional(),
  "withContactFromOwner": zod.enum(['true', 'false']).optional(),
  "withContactFromTenant": zod.enum(['true', 'false']).optional(),
  "withContactFromTenantFiles": zod.enum(['true', 'false']).optional(),
  "withContactFromAdmin": zod.enum(['true', 'false']).optional(),
  "withContactToOwner": zod.enum(['true', 'false']).optional(),
  "withContactToTenant": zod.enum(['true', 'false']).optional(),
  "withContactToTenantFiles": zod.enum(['true', 'false']).optional(),
  "withContactToAdmin": zod.enum(['true', 'false']).optional()
})

export const ticketGetResponseTicketContentMax = 1000;
export const ticketGetResponseTicketAlertCommentMax = 1000;
export const ticketGetResponseTicketOcCommentMax = 1000;
export const ticketGetResponseTicketContactFromTextMax = 255;
export const ticketGetResponseTicketContactToTextMax = 255;
export const ticketGetResponseTicketNoteMax = 1000;
export const ticketGetResponseTicketContractorNameMax = 255;
export const ticketGetResponseTicketContractorContactMax = 255;
export const ticketGetResponseTicketContractorContactInfoMax = 500;
export const ticketGetResponseTicketContractorScheduledDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContractorNoteMax = 1000;
export const ticketGetResponseTicketPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const ticketGetResponseTicketPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const ticketGetResponseTicketRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const ticketGetResponseTicketRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const ticketGetResponseTicketTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTenantPhone1Max = 4;

export const ticketGetResponseTicketTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTenantPhone2Max = 4;

export const ticketGetResponseTicketTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTenantPhone3Max = 4;

export const ticketGetResponseTicketTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTenantPhone4Max = 4;

export const ticketGetResponseTicketTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTenantPhone5Max = 4;

export const ticketGetResponseTicketTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTenantPhone6Max = 4;

export const ticketGetResponseTicketTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTenantOccupantsItemPhoneMax = 20;
export const ticketGetResponseTicketTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTenantOccupantsItemNoteMax = 1000;
export const ticketGetResponseTicketOcAssigneeNameKanaMax = 255;
export const ticketGetResponseTicketOcAssigneeDepartmentMax = 255;
export const ticketGetResponseTicketOcAssigneeRoleMax = 255;

export const ticketGetResponseTicketOcAssigneeRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone1Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone2Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone3Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone4Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone5Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone6Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantOccupantsItemPhoneMax = 20;
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactFromTenantOccupantsItemNoteMax = 1000;
export const ticketGetResponseTicketTicketCommentsItemContactFromAdminNameKanaMax = 255;
export const ticketGetResponseTicketTicketCommentsItemContactFromAdminDepartmentMax = 255;
export const ticketGetResponseTicketTicketCommentsItemContactFromAdminRoleMax = 255;

export const ticketGetResponseTicketTicketCommentsItemContactFromAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone1Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone2Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone3Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone4Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone5Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone6Max = 4;

export const ticketGetResponseTicketTicketCommentsItemContactToTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantOccupantsItemPhoneMax = 20;
export const ticketGetResponseTicketTicketCommentsItemContactToTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketTicketCommentsItemContactToTenantOccupantsItemNoteMax = 1000;
export const ticketGetResponseTicketTicketCommentsItemContactToAdminNameKanaMax = 255;
export const ticketGetResponseTicketTicketCommentsItemContactToAdminDepartmentMax = 255;
export const ticketGetResponseTicketTicketCommentsItemContactToAdminRoleMax = 255;

export const ticketGetResponseTicketTicketCommentsItemContactToAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketGetResponseTicketTicketMessagesItemAdminNameKanaMax = 255;
export const ticketGetResponseTicketTicketMessagesItemAdminDepartmentMax = 255;
export const ticketGetResponseTicketTicketMessagesItemAdminRoleMax = 255;

export const ticketGetResponseTicketTicketMessagesItemAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketGetResponseTicketContactFromTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketContactFromTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactFromTenantPhone1Max = 4;

export const ticketGetResponseTicketContactFromTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketContactFromTenantPhone2Max = 4;

export const ticketGetResponseTicketContactFromTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketContactFromTenantPhone3Max = 4;

export const ticketGetResponseTicketContactFromTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketContactFromTenantPhone4Max = 4;

export const ticketGetResponseTicketContactFromTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketContactFromTenantPhone5Max = 4;

export const ticketGetResponseTicketContactFromTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketContactFromTenantPhone6Max = 4;

export const ticketGetResponseTicketContactFromTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketContactFromTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactFromTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactFromTenantOccupantsItemPhoneMax = 20;
export const ticketGetResponseTicketContactFromTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactFromTenantOccupantsItemNoteMax = 1000;
export const ticketGetResponseTicketContactFromAdminNameKanaMax = 255;
export const ticketGetResponseTicketContactFromAdminDepartmentMax = 255;
export const ticketGetResponseTicketContactFromAdminRoleMax = 255;

export const ticketGetResponseTicketContactFromAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketGetResponseTicketContactToTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketGetResponseTicketContactToTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactToTenantPhone1Max = 4;

export const ticketGetResponseTicketContactToTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketContactToTenantPhone2Max = 4;

export const ticketGetResponseTicketContactToTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketContactToTenantPhone3Max = 4;

export const ticketGetResponseTicketContactToTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketGetResponseTicketContactToTenantPhone4Max = 4;

export const ticketGetResponseTicketContactToTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketContactToTenantPhone5Max = 4;

export const ticketGetResponseTicketContactToTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketContactToTenantPhone6Max = 4;

export const ticketGetResponseTicketContactToTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketGetResponseTicketContactToTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactToTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactToTenantOccupantsItemPhoneMax = 20;
export const ticketGetResponseTicketContactToTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketGetResponseTicketContactToTenantOccupantsItemNoteMax = 1000;
export const ticketGetResponseTicketContactToAdminNameKanaMax = 255;
export const ticketGetResponseTicketContactToAdminDepartmentMax = 255;
export const ticketGetResponseTicketContactToAdminRoleMax = 255;

export const ticketGetResponseTicketContactToAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const ticketGetResponse = zod.object({
  "ticket": zod.object({
  "id": zod.number().describe('チケットID'),
  "ownerId": zod.string().describe('対象オーナーID'),
  "propertyId": zod.number().nullable().describe('対象物件ID。物件が特定できない場合は null'),
  "roomId": zod.number().nullable().describe('対象部屋ID。部屋が特定できない場合は null'),
  "tenantId": zod.number().nullable().describe('対象賃借人ID。賃借人が特定できない場合は null'),
  "title": zod.string().describe('チケットの件名'),
  "content": zod.string().max(ticketGetResponseTicketContentMax).describe('問い合わせ・依頼の内容'),
  "category": zod.enum(['toiawase', 'kaiyaku-kanren', 'kuremu-hado', 'kuremu-sofuto', 'sonota', 'sabisu-ni-tsuite', 'shinki-nyukyosha-shonin', 'kaiyaku-uketsuke']).describe('カテゴリ（toiawase:問い合せ / kaiyaku-kanren:解約関連 / kuremu-hado:クレームハード / kuremu-sofuto:クレームソフト / sonota:その他 / sabisu-ni-tsuite:サービスについて / shinki-nyukyosha-shonin:新規入居者承認 / kaiyaku-uketsuke:解約受付）'),
  "subCategory": zod.enum(['kagi-autorokku', 'merubokkusu-takuhai-bokkusu', 'intanetto-terebi-denwa', 'eakon-kanren', 'setsubi-kanren-shiyo-hoho-to', 'chushajo-churinjo', 'yachin-suido-dai', 'hosho-gaisha', 'shorui-kankei', 'hoken', 'koshin-saikeiyaku', 'meigi-henko', 'nyukyosha-joho-henko', 'raifurain', 'kyoju-ruru', 'anpi-kyoju-kakunin', 'sonota-toiawase', 'kaiyaku-tetsuzuki-hoho', 'kaiyaku-bi-henko-torikeshi', 'taikyo-tachiai', 'taikyo-seisan', 'shikikin-henkin-koza-tenkyo-saki-jusho', 'eakon', 'kyutoki', 'nyukyoji-fuguai', 'mizumawari', 'toire-woshuretto', 'rosui', 'intahon-chaimu', 'konro', 'tategu', 'terebi', 'intanetto', 'kyoyobu', 'kagi-genkan', 'kanki-kanren', 'shomei-kigu', 'bureka-denki-kanren', 'keihoki', 'kurosu-yuka-tatami', 'kabi-ketsuro', 'chushajo', 'churinjo', 'so-on', 'gomi', 'shokubutsu', 'seibutsu', 'kitsuen', 'nioi', 'kyoyobu-no-shiyo-ni-tsuite-shibutsu', 'kyoyobu-no-yogore-seiso', 'sonota', 'sabisu-toiawase', 'shinki-keiyaku-shonin-kakunin', 'kaiyaku-uketsuke-kakunin']).describe('サブカテゴリ。category に紐づく詳細分類'),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('対応ステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "occurredAt": zod.string().describe('事象の発生日時（ISO8601）'),
  "alertAt": zod.string().nullable().describe('アラートを設定した日時（ISO8601）。null はアラートなし'),
  "alertComment": zod.string().max(ticketGetResponseTicketAlertCommentMax).describe('アラートの内容'),
  "ocComment": zod.string().max(ticketGetResponseTicketOcCommentMax).describe('OC（オペレーションセンター）の対応コメント'),
  "ocAssigneeId": zod.string().nullable().describe('OC担当者の管理者ID'),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullable().describe('連絡元がオーナーの場合のオーナーID'),
  "contactFromTenantId": zod.number().nullable().describe('連絡元が賃借人の場合の賃借人ID'),
  "contactFromAdminId": zod.string().nullable().describe('連絡元が管理者の場合の管理者ID'),
  "contactFromText": zod.string().max(ticketGetResponseTicketContactFromTextMax).nullable().describe('連絡元をIDで특定できない場合の自由記述'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullable().describe('連絡先がオーナーの場合のオーナーID'),
  "contactToTenantId": zod.number().nullable().describe('連絡先が賃借人の場合の賃借人ID'),
  "contactToAdminId": zod.string().nullable().describe('連絡先が管理者の場合の管理者ID'),
  "contactToText": zod.string().max(ticketGetResponseTicketContactToTextMax).nullable().describe('連絡先をIDで特定できない場合の自由記述'),
  "note": zod.string().max(ticketGetResponseTicketNoteMax).describe('備考'),
  "isMessageReadByAdmin": zod.boolean().describe('管理者がチケットのメッセージを読んだかどうか'),
  "contractorStatus": zod.union([zod.literal('estimate_requested'),zod.literal('work_requested'),zod.literal('order_requested'),zod.literal('estimate_received'),zod.literal('owner_confirming'),zod.literal('completed'),zod.literal(null)]).nullable().describe('業者対応の進捗（estimate_requested:見積依頼中 / work_requested:業務依頼済 / order_requested:発注依頼済 / estimate_received:見積受領済 / owner_confirming:オーナー確認中 / completed:完了）'),
  "contractorType": zod.union([zod.literal('agentcall'),zod.literal('owner_specified'),zod.literal(null)]).nullable().describe('手配した業者の区分（agentcall:エージェントコール業者 / owner_specified:オーナー様指定業者）'),
  "contractorName": zod.string().max(ticketGetResponseTicketContractorNameMax).describe('手配した業者名'),
  "contractorContact": zod.string().max(ticketGetResponseTicketContractorContactMax).describe('手配した業者の担当者'),
  "contractorContactInfo": zod.string().max(ticketGetResponseTicketContractorContactInfoMax).describe('手配した業者の連絡先'),
  "contractorScheduledDate": zod.string().regex(ticketGetResponseTicketContractorScheduledDateRegExp).nullable().describe('業者の対応予定日（YYYY-MM-DD）'),
  "contractorNote": zod.string().max(ticketGetResponseTicketContractorNoteMax).describe('業者対応に関する備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "createdOwnerId": zod.string().nullable().describe('チケットを起票したオーナーID。管理者起票の場合は null'),
  "createdAdminId": zod.string().nullable().describe('チケットを起票した管理者ID。オーナー起票の場合は null'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(ticketGetResponseTicketPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(ticketGetResponseTicketPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(ticketGetResponseTicketPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(ticketGetResponseTicketPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(ticketGetResponseTicketPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(ticketGetResponseTicketRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(ticketGetResponseTicketRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(ticketGetResponseTicketRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(ticketGetResponseTicketRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(ticketGetResponseTicketRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "tenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketGetResponseTicketTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketGetResponseTicketTenantPhone1Max).regex(ticketGetResponseTicketTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketGetResponseTicketTenantPhone2Max).regex(ticketGetResponseTicketTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketGetResponseTicketTenantPhone3Max).regex(ticketGetResponseTicketTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketGetResponseTicketTenantPhone4Max).regex(ticketGetResponseTicketTenantPhone4RegExp),
  "phone5": zod.string().max(ticketGetResponseTicketTenantPhone5Max).regex(ticketGetResponseTicketTenantPhone5RegExp),
  "phone6": zod.string().max(ticketGetResponseTicketTenantPhone6Max).regex(ticketGetResponseTicketTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketGetResponseTicketTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketGetResponseTicketTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketGetResponseTicketTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketGetResponseTicketTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketGetResponseTicketTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "ocAssignee": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketGetResponseTicketOcAssigneeNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketGetResponseTicketOcAssigneeDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketGetResponseTicketOcAssigneeRoleMax).regex(ticketGetResponseTicketOcAssigneeRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "ticketComments": zod.array(zod.object({
  "id": zod.number().describe('対応履歴ID'),
  "ticketId": zod.number().describe('紐づくチケットID'),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('この対応履歴を登録した時点のチケットステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "contactAt": zod.string().describe('連絡日時'),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullable().describe('連絡者(FROM)オーナーID'),
  "contactFromTenantId": zod.number().nullable().describe('連絡者(FROM)賃借人ID'),
  "contactFromAdminId": zod.string().nullable().describe('連絡者(FROM)管理者ID'),
  "contactFromText": zod.string().nullable().describe('連絡者(FROM)テキスト'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullable().describe('連絡者(TO)オーナーID'),
  "contactToTenantId": zod.number().nullable().describe('連絡者(TO)賃借人ID'),
  "contactToAdminId": zod.string().nullable().describe('連絡者(TO)管理者ID'),
  "contactToText": zod.string().nullable().describe('連絡者(TO)テキスト'),
  "content": zod.string().describe('連絡内容'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "contactFromOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactFromTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone1Max).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone2Max).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone3Max).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone4Max).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone4RegExp),
  "phone5": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone5Max).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone5RegExp),
  "phone6": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone6Max).regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactFromTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactFromAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactFromAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactFromAdminRoleMax).regex(ticketGetResponseTicketTicketCommentsItemContactFromAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "contactToOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactToTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone1Max).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone2Max).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone3Max).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone4Max).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone4RegExp),
  "phone5": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone5Max).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone5RegExp),
  "phone6": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone6Max).regex(ticketGetResponseTicketTicketCommentsItemContactToTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactToTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactToTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketGetResponseTicketTicketCommentsItemContactToTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketGetResponseTicketTicketCommentsItemContactToAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketGetResponseTicketTicketCommentsItemContactToAdminRoleMax).regex(ticketGetResponseTicketTicketCommentsItemContactToAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).nullish(),
  "ticketMessages": zod.array(zod.object({
  "id": zod.number().describe('チケットメッセージID'),
  "ticketId": zod.number().describe('紐づくチケットID'),
  "senderType": zod.enum(['owner', 'admin', 'system']).describe('送信者種別'),
  "message": zod.string().describe('メッセージ本文'),
  "readAt": zod.string().nullable().describe('既読日時（ISO8601）。null は未読'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "ownerId": zod.string().nullable().describe('送信者がオーナーの場合のオーナーID'),
  "adminId": zod.string().nullable().describe('送信者が管理者の場合の管理者ID'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "admin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketGetResponseTicketTicketMessagesItemAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketGetResponseTicketTicketMessagesItemAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketGetResponseTicketTicketMessagesItemAdminRoleMax).regex(ticketGetResponseTicketTicketMessagesItemAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "ticket": zod.any().nullish().describe('紐づくチケット情報（TicketResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メッセージに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).nullish(),
  "contactFromOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "contactFromTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketContactFromTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketGetResponseTicketContactFromTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketGetResponseTicketContactFromTenantPhone1Max).regex(ticketGetResponseTicketContactFromTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketGetResponseTicketContactFromTenantPhone2Max).regex(ticketGetResponseTicketContactFromTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketGetResponseTicketContactFromTenantPhone3Max).regex(ticketGetResponseTicketContactFromTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketGetResponseTicketContactFromTenantPhone4Max).regex(ticketGetResponseTicketContactFromTenantPhone4RegExp),
  "phone5": zod.string().max(ticketGetResponseTicketContactFromTenantPhone5Max).regex(ticketGetResponseTicketContactFromTenantPhone5RegExp),
  "phone6": zod.string().max(ticketGetResponseTicketContactFromTenantPhone6Max).regex(ticketGetResponseTicketContactFromTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketGetResponseTicketContactFromTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketGetResponseTicketContactFromTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketGetResponseTicketContactFromTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketGetResponseTicketContactFromTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketGetResponseTicketContactFromTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactFromAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketGetResponseTicketContactFromAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketGetResponseTicketContactFromAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketGetResponseTicketContactFromAdminRoleMax).regex(ticketGetResponseTicketContactFromAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "contactToOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketGetResponseTicketContactToTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketGetResponseTicketContactToTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketGetResponseTicketContactToTenantPhone1Max).regex(ticketGetResponseTicketContactToTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketGetResponseTicketContactToTenantPhone2Max).regex(ticketGetResponseTicketContactToTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketGetResponseTicketContactToTenantPhone3Max).regex(ticketGetResponseTicketContactToTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketGetResponseTicketContactToTenantPhone4Max).regex(ticketGetResponseTicketContactToTenantPhone4RegExp),
  "phone5": zod.string().max(ticketGetResponseTicketContactToTenantPhone5Max).regex(ticketGetResponseTicketContactToTenantPhone5RegExp),
  "phone6": zod.string().max(ticketGetResponseTicketContactToTenantPhone6Max).regex(ticketGetResponseTicketContactToTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketGetResponseTicketContactToTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketGetResponseTicketContactToTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketGetResponseTicketContactToTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketGetResponseTicketContactToTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketGetResponseTicketContactToTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketGetResponseTicketContactToAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketGetResponseTicketContactToAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketGetResponseTicketContactToAdminRoleMax).regex(ticketGetResponseTicketContactToAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})
})


/**
 * @summary ticketUpdate
 */
export const ticketUpdateParams = zod.object({
  "id": zod.string()
})

export const ticketUpdateBodyContractorNameMax = 255;
export const ticketUpdateBodyContractorContactMax = 255;
export const ticketUpdateBodyContractorContactInfoMax = 500;
export const ticketUpdateBodyContractorScheduledDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketUpdateBodyOcCommentMax = 1000;
export const ticketUpdateBodyAlertCommentMax = 1000;
export const ticketUpdateBodyNoteMax = 1000;


export const ticketUpdateBody = zod.object({
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('対応ステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "title": zod.string().min(1).describe('チケットの件名'),
  "category": zod.enum(['toiawase', 'kaiyaku-kanren', 'kuremu-hado', 'kuremu-sofuto', 'sonota', 'sabisu-ni-tsuite', 'shinki-nyukyosha-shonin', 'kaiyaku-uketsuke']).describe('カテゴリ（toiawase:問い合せ / kaiyaku-kanren:解約関連 / kuremu-hado:クレームハード / kuremu-sofuto:クレームソフト / sonota:その他 / sabisu-ni-tsuite:サービスについて / shinki-nyukyosha-shonin:新規入居者承認 / kaiyaku-uketsuke:解約受付）'),
  "ocAssigneeId": zod.string().nullable().describe('OC担当者の管理者ID'),
  "occurredAt": zod.string(),
  "contractorStatus": zod.union([zod.literal('estimate_requested'),zod.literal('work_requested'),zod.literal('order_requested'),zod.literal('estimate_received'),zod.literal('owner_confirming'),zod.literal('completed'),zod.literal(null)]).nullable().describe('業者対応の進捗（estimate_requested:見積依頼中 / work_requested:業務依頼済 / order_requested:発注依頼済 / estimate_received:見積受領済 / owner_confirming:オーナー確認中 / completed:完了）'),
  "contractorType": zod.union([zod.literal('agentcall'),zod.literal('owner_specified'),zod.literal(null)]).nullable().describe('手配した業者の区分（agentcall:エージェントコール業者 / owner_specified:オーナー様指定業者）'),
  "contractorName": zod.string().max(ticketUpdateBodyContractorNameMax).describe('手配した業者名'),
  "contractorContact": zod.string().max(ticketUpdateBodyContractorContactMax).describe('手配した業者の担当者'),
  "contractorContactInfo": zod.string().max(ticketUpdateBodyContractorContactInfoMax).describe('手配した業者の連絡先'),
  "contractorScheduledDate": zod.string().regex(ticketUpdateBodyContractorScheduledDateRegExp).nullable().describe('業者の対応予定日（YYYY-MM-DD）'),
  "ocComment": zod.string().max(ticketUpdateBodyOcCommentMax).describe('OC（オペレーションセンター）の対応コメント'),
  "alertAt": zod.string().nullable(),
  "alertComment": zod.string().max(ticketUpdateBodyAlertCommentMax).describe('アラートの内容'),
  "note": zod.string().max(ticketUpdateBodyNoteMax).describe('備考')
})

export const ticketUpdateResponse = zod.object({
  "id": zod.number().describe('チケットID')
})


/**
 * @summary ticketDelete
 */
export const ticketDeleteParams = zod.object({
  "id": zod.string()
})

export const ticketDeleteResponse = zod.object({
  "id": zod.number().describe('チケットID')
})


/**
 * @summary ticketList
 */
export const ticketListQueryPageDefault = 1;export const ticketListQueryLimitDefault = 10;

export const ticketListQueryParams = zod.object({
  "page": zod.number().default(ticketListQueryPageDefault),
  "limit": zod.number().default(ticketListQueryLimitDefault),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).optional(),
  "ticketId": zod.number().nullish(),
  "ocAssigneeId": zod.string().optional(),
  "ocAssigneeName": zod.string().optional(),
  "alertFrom": zod.string().optional(),
  "alertTo": zod.string().optional(),
  "title": zod.string().optional(),
  "tenantName": zod.string().optional(),
  "roomName": zod.string().optional(),
  "propertyName": zod.string().optional(),
  "ownerName": zod.string().optional(),
  "isMessageRead": zod.enum(['true', 'false']).optional(),
  "withOwner": zod.enum(['true', 'false']).optional(),
  "withProperty": zod.enum(['true', 'false']).optional(),
  "withRoom": zod.enum(['true', 'false']).optional(),
  "withRoomPlans": zod.enum(['true', 'false']).optional(),
  "withTenant": zod.enum(['true', 'false']).optional(),
  "withTenantFiles": zod.enum(['true', 'false']).optional(),
  "withOcAssignee": zod.enum(['true', 'false']).optional(),
  "withTicketComments": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactFromOwner": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactFromTenant": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactFromAdmin": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactToOwner": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactToTenant": zod.enum(['true', 'false']).optional(),
  "withTicketCommentsContactToAdmin": zod.enum(['true', 'false']).optional(),
  "withTicketMessages": zod.enum(['true', 'false']).optional(),
  "withTicketMessagesFiles": zod.enum(['true', 'false']).optional(),
  "withContactFromOwner": zod.enum(['true', 'false']).optional(),
  "withContactFromTenant": zod.enum(['true', 'false']).optional(),
  "withContactFromTenantFiles": zod.enum(['true', 'false']).optional(),
  "withContactFromAdmin": zod.enum(['true', 'false']).optional(),
  "withContactToOwner": zod.enum(['true', 'false']).optional(),
  "withContactToTenant": zod.enum(['true', 'false']).optional(),
  "withContactToTenantFiles": zod.enum(['true', 'false']).optional(),
  "withContactToAdmin": zod.enum(['true', 'false']).optional()
})

export const ticketListResponseTicketsItemContentMax = 1000;
export const ticketListResponseTicketsItemAlertCommentMax = 1000;
export const ticketListResponseTicketsItemOcCommentMax = 1000;
export const ticketListResponseTicketsItemContactFromTextMax = 255;
export const ticketListResponseTicketsItemContactToTextMax = 255;
export const ticketListResponseTicketsItemNoteMax = 1000;
export const ticketListResponseTicketsItemContractorNameMax = 255;
export const ticketListResponseTicketsItemContractorContactMax = 255;
export const ticketListResponseTicketsItemContractorContactInfoMax = 500;
export const ticketListResponseTicketsItemContractorScheduledDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContractorNoteMax = 1000;
export const ticketListResponseTicketsItemPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const ticketListResponseTicketsItemPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const ticketListResponseTicketsItemRoomPropertyNameRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemRoomPropertyNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemRoomPropertyPrefectureKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemRoomPropertyCityKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemRoomPropertyTownKanaRegExp = new RegExp('^[ァ-ヴー0-9０-９\\-− 　]+$');
export const ticketListResponseTicketsItemRoomPropertyDistrictRegExp = new RegExp('^[0-9０-９\\p{P}\\p{S}\\s]+$/u');
export const ticketListResponseTicketsItemTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTenantPhone1Max = 4;

export const ticketListResponseTicketsItemTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTenantPhone2Max = 4;

export const ticketListResponseTicketsItemTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTenantPhone3Max = 4;

export const ticketListResponseTicketsItemTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTenantPhone4Max = 4;

export const ticketListResponseTicketsItemTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTenantPhone5Max = 4;

export const ticketListResponseTicketsItemTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTenantPhone6Max = 4;

export const ticketListResponseTicketsItemTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTenantOccupantsItemPhoneMax = 20;
export const ticketListResponseTicketsItemTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTenantOccupantsItemNoteMax = 1000;
export const ticketListResponseTicketsItemOcAssigneeNameKanaMax = 255;
export const ticketListResponseTicketsItemOcAssigneeDepartmentMax = 255;
export const ticketListResponseTicketsItemOcAssigneeRoleMax = 255;

export const ticketListResponseTicketsItemOcAssigneeRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone1Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone2Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone3Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone4Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone5Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone6Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantOccupantsItemPhoneMax = 20;
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactFromTenantOccupantsItemNoteMax = 1000;
export const ticketListResponseTicketsItemTicketCommentsItemContactFromAdminNameKanaMax = 255;
export const ticketListResponseTicketsItemTicketCommentsItemContactFromAdminDepartmentMax = 255;
export const ticketListResponseTicketsItemTicketCommentsItemContactFromAdminRoleMax = 255;

export const ticketListResponseTicketsItemTicketCommentsItemContactFromAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone1Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone2Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone3Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone4Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone5Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone6Max = 4;

export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantOccupantsItemPhoneMax = 20;
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemTicketCommentsItemContactToTenantOccupantsItemNoteMax = 1000;
export const ticketListResponseTicketsItemTicketCommentsItemContactToAdminNameKanaMax = 255;
export const ticketListResponseTicketsItemTicketCommentsItemContactToAdminDepartmentMax = 255;
export const ticketListResponseTicketsItemTicketCommentsItemContactToAdminRoleMax = 255;

export const ticketListResponseTicketsItemTicketCommentsItemContactToAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketListResponseTicketsItemTicketMessagesItemAdminNameKanaMax = 255;
export const ticketListResponseTicketsItemTicketMessagesItemAdminDepartmentMax = 255;
export const ticketListResponseTicketsItemTicketMessagesItemAdminRoleMax = 255;

export const ticketListResponseTicketsItemTicketMessagesItemAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketListResponseTicketsItemContactFromTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemContactFromTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactFromTenantPhone1Max = 4;

export const ticketListResponseTicketsItemContactFromTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemContactFromTenantPhone2Max = 4;

export const ticketListResponseTicketsItemContactFromTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemContactFromTenantPhone3Max = 4;

export const ticketListResponseTicketsItemContactFromTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemContactFromTenantPhone4Max = 4;

export const ticketListResponseTicketsItemContactFromTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemContactFromTenantPhone5Max = 4;

export const ticketListResponseTicketsItemContactFromTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemContactFromTenantPhone6Max = 4;

export const ticketListResponseTicketsItemContactFromTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemContactFromTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactFromTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactFromTenantOccupantsItemPhoneMax = 20;
export const ticketListResponseTicketsItemContactFromTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactFromTenantOccupantsItemNoteMax = 1000;
export const ticketListResponseTicketsItemContactFromAdminNameKanaMax = 255;
export const ticketListResponseTicketsItemContactFromAdminDepartmentMax = 255;
export const ticketListResponseTicketsItemContactFromAdminRoleMax = 255;

export const ticketListResponseTicketsItemContactFromAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const ticketListResponseTicketsItemContactToTenantNameKanaRegExp = new RegExp('^[ァ-ヶー 　]+$');
export const ticketListResponseTicketsItemContactToTenantBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactToTenantPhone1Max = 4;

export const ticketListResponseTicketsItemContactToTenantPhone1RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemContactToTenantPhone2Max = 4;

export const ticketListResponseTicketsItemContactToTenantPhone2RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemContactToTenantPhone3Max = 4;

export const ticketListResponseTicketsItemContactToTenantPhone3RegExp = new RegExp('^\\d{1,4}$');
export const ticketListResponseTicketsItemContactToTenantPhone4Max = 4;

export const ticketListResponseTicketsItemContactToTenantPhone4RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemContactToTenantPhone5Max = 4;

export const ticketListResponseTicketsItemContactToTenantPhone5RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemContactToTenantPhone6Max = 4;

export const ticketListResponseTicketsItemContactToTenantPhone6RegExp = new RegExp('^\\d*$');
export const ticketListResponseTicketsItemContactToTenantStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactToTenantEndDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactToTenantOccupantsItemPhoneMax = 20;
export const ticketListResponseTicketsItemContactToTenantOccupantsItemBirthdayRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketListResponseTicketsItemContactToTenantOccupantsItemNoteMax = 1000;
export const ticketListResponseTicketsItemContactToAdminNameKanaMax = 255;
export const ticketListResponseTicketsItemContactToAdminDepartmentMax = 255;
export const ticketListResponseTicketsItemContactToAdminRoleMax = 255;

export const ticketListResponseTicketsItemContactToAdminRoleRegExp = new RegExp('^[a-z][a-z0-9_]*$');


export const ticketListResponse = zod.object({
  "total": zod.number(),
  "tickets": zod.array(zod.object({
  "id": zod.number().describe('チケットID'),
  "ownerId": zod.string().describe('対象オーナーID'),
  "propertyId": zod.number().nullable().describe('対象物件ID。物件が特定できない場合は null'),
  "roomId": zod.number().nullable().describe('対象部屋ID。部屋が特定できない場合は null'),
  "tenantId": zod.number().nullable().describe('対象賃借人ID。賃借人が特定できない場合は null'),
  "title": zod.string().describe('チケットの件名'),
  "content": zod.string().max(ticketListResponseTicketsItemContentMax).describe('問い合わせ・依頼の内容'),
  "category": zod.enum(['toiawase', 'kaiyaku-kanren', 'kuremu-hado', 'kuremu-sofuto', 'sonota', 'sabisu-ni-tsuite', 'shinki-nyukyosha-shonin', 'kaiyaku-uketsuke']).describe('カテゴリ（toiawase:問い合せ / kaiyaku-kanren:解約関連 / kuremu-hado:クレームハード / kuremu-sofuto:クレームソフト / sonota:その他 / sabisu-ni-tsuite:サービスについて / shinki-nyukyosha-shonin:新規入居者承認 / kaiyaku-uketsuke:解約受付）'),
  "subCategory": zod.enum(['kagi-autorokku', 'merubokkusu-takuhai-bokkusu', 'intanetto-terebi-denwa', 'eakon-kanren', 'setsubi-kanren-shiyo-hoho-to', 'chushajo-churinjo', 'yachin-suido-dai', 'hosho-gaisha', 'shorui-kankei', 'hoken', 'koshin-saikeiyaku', 'meigi-henko', 'nyukyosha-joho-henko', 'raifurain', 'kyoju-ruru', 'anpi-kyoju-kakunin', 'sonota-toiawase', 'kaiyaku-tetsuzuki-hoho', 'kaiyaku-bi-henko-torikeshi', 'taikyo-tachiai', 'taikyo-seisan', 'shikikin-henkin-koza-tenkyo-saki-jusho', 'eakon', 'kyutoki', 'nyukyoji-fuguai', 'mizumawari', 'toire-woshuretto', 'rosui', 'intahon-chaimu', 'konro', 'tategu', 'terebi', 'intanetto', 'kyoyobu', 'kagi-genkan', 'kanki-kanren', 'shomei-kigu', 'bureka-denki-kanren', 'keihoki', 'kurosu-yuka-tatami', 'kabi-ketsuro', 'chushajo', 'churinjo', 'so-on', 'gomi', 'shokubutsu', 'seibutsu', 'kitsuen', 'nioi', 'kyoyobu-no-shiyo-ni-tsuite-shibutsu', 'kyoyobu-no-yogore-seiso', 'sonota', 'sabisu-toiawase', 'shinki-keiyaku-shonin-kakunin', 'kaiyaku-uketsuke-kakunin']).describe('サブカテゴリ。category に紐づく詳細分類'),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('対応ステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "occurredAt": zod.string().describe('事象の発生日時（ISO8601）'),
  "alertAt": zod.string().nullable().describe('アラートを設定した日時（ISO8601）。null はアラートなし'),
  "alertComment": zod.string().max(ticketListResponseTicketsItemAlertCommentMax).describe('アラートの内容'),
  "ocComment": zod.string().max(ticketListResponseTicketsItemOcCommentMax).describe('OC（オペレーションセンター）の対応コメント'),
  "ocAssigneeId": zod.string().nullable().describe('OC担当者の管理者ID'),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullable().describe('連絡元がオーナーの場合のオーナーID'),
  "contactFromTenantId": zod.number().nullable().describe('連絡元が賃借人の場合の賃借人ID'),
  "contactFromAdminId": zod.string().nullable().describe('連絡元が管理者の場合の管理者ID'),
  "contactFromText": zod.string().max(ticketListResponseTicketsItemContactFromTextMax).nullable().describe('連絡元をIDで특定できない場合の自由記述'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullable().describe('連絡先がオーナーの場合のオーナーID'),
  "contactToTenantId": zod.number().nullable().describe('連絡先が賃借人の場合の賃借人ID'),
  "contactToAdminId": zod.string().nullable().describe('連絡先が管理者の場合の管理者ID'),
  "contactToText": zod.string().max(ticketListResponseTicketsItemContactToTextMax).nullable().describe('連絡先をIDで特定できない場合の自由記述'),
  "note": zod.string().max(ticketListResponseTicketsItemNoteMax).describe('備考'),
  "isMessageReadByAdmin": zod.boolean().describe('管理者がチケットのメッセージを読んだかどうか'),
  "contractorStatus": zod.union([zod.literal('estimate_requested'),zod.literal('work_requested'),zod.literal('order_requested'),zod.literal('estimate_received'),zod.literal('owner_confirming'),zod.literal('completed'),zod.literal(null)]).nullable().describe('業者対応の進捗（estimate_requested:見積依頼中 / work_requested:業務依頼済 / order_requested:発注依頼済 / estimate_received:見積受領済 / owner_confirming:オーナー確認中 / completed:完了）'),
  "contractorType": zod.union([zod.literal('agentcall'),zod.literal('owner_specified'),zod.literal(null)]).nullable().describe('手配した業者の区分（agentcall:エージェントコール業者 / owner_specified:オーナー様指定業者）'),
  "contractorName": zod.string().max(ticketListResponseTicketsItemContractorNameMax).describe('手配した業者名'),
  "contractorContact": zod.string().max(ticketListResponseTicketsItemContractorContactMax).describe('手配した業者の担当者'),
  "contractorContactInfo": zod.string().max(ticketListResponseTicketsItemContractorContactInfoMax).describe('手配した業者の連絡先'),
  "contractorScheduledDate": zod.string().regex(ticketListResponseTicketsItemContractorScheduledDateRegExp).nullable().describe('業者の対応予定日（YYYY-MM-DD）'),
  "contractorNote": zod.string().max(ticketListResponseTicketsItemContractorNoteMax).describe('業者対応に関する備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "createdOwnerId": zod.string().nullable().describe('チケットを起票したオーナーID。管理者起票の場合は null'),
  "createdAdminId": zod.string().nullable().describe('チケットを起票した管理者ID。オーナー起票の場合は null'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(ticketListResponseTicketsItemPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(ticketListResponseTicketsItemPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(ticketListResponseTicketsItemPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(ticketListResponseTicketsItemPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(ticketListResponseTicketsItemPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "room": zod.object({
  "id": zod.number().describe('部屋ID'),
  "propertyId": zod.number().describe('部屋が属する物件ID'),
  "name": zod.string().describe('部屋番号'),
  "layout": zod.string().describe('間取り'),
  "size": zod.number().describe('専有面積（平方メートル）'),
  "floor": zod.number().describe('部屋の所在階'),
  "echoesResidenceId": zod.string().nullable().describe('Echoes の部屋ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "property": zod.object({
  "id": zod.number().describe('物件ID'),
  "ownerId": zod.string().describe('物件を所有するオーナーID'),
  "name": zod.string().min(1).regex(ticketListResponseTicketsItemRoomPropertyNameRegExp).describe('物件名カナ'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemRoomPropertyNameKanaRegExp).describe('物件名カナ'),
  "upperZip": zod.string().min(1).describe('郵便番号の上3桁'),
  "lowerZip": zod.string().min(1).describe('郵便番号の下4桁'),
  "prefecture": zod.string().min(1).describe('都道府県'),
  "prefectureKana": zod.string().min(1).regex(ticketListResponseTicketsItemRoomPropertyPrefectureKanaRegExp).describe('都道府県カナ'),
  "city": zod.string().min(1).describe('市区町村'),
  "cityKana": zod.string().min(1).regex(ticketListResponseTicketsItemRoomPropertyCityKanaRegExp).describe('市区町村カナ'),
  "town": zod.string().min(1).describe('町名'),
  "townKana": zod.string().min(1).regex(ticketListResponseTicketsItemRoomPropertyTownKanaRegExp).describe('町名カナ'),
  "district": zod.string().min(1).regex(ticketListResponseTicketsItemRoomPropertyDistrictRegExp).describe('丁目・番地・建物番号'),
  "districtKana": zod.string().describe('丁目・番地・建物番号カナ'),
  "builtYear": zod.number().describe('築年（西暦）'),
  "structure": zod.enum(['1', '2', '3', '4']).describe('建物構造（1:木造 / 2:鉄骨造 / 3:RC造・SRC造・PC造 / 4:その他）'),
  "type": zod.enum(['1', '2', '3']).describe('用法（1:専用住宅 / 2:共同住宅 / 3:併用住宅）'),
  "floor": zod.number().describe('建物の階数'),
  "ownershipType": zod.enum(['WHOLE', 'CONDO']).describe('物件の所有形態（WHOLE: 一棟所有 / CONDO: 区分所有）'),
  "managementCompanyName": zod.string().describe('建物管理会社名'),
  "managementCompanyPhone": zod.string().describe('建物管理会社の電話番号（ハイフンなし）'),
  "note": zod.string().describe('備考'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "echoesBuildingId": zod.string().nullable().describe('Echoes の建物ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "rooms": zod.array(zod.any().nullable()).optional().describe('物件に属する部屋の一覧（RoomResponse 相当。取得指定時のみ含まれる）'),
  "roomCount": zod.number().optional().describe('物件に属する部屋数（withRooms 指定時のみ含まれる）'),
  "currentPlanCount": zod.number().optional().describe('契約中のプラン数（withRoomsPlans 指定時のみ含まれる）'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "tenants": zod.array(zod.any().nullable()).optional().describe('部屋の賃借人一覧（TenantResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('部屋に紐づくプラン契約の一覧（PlanResponse 相当。取得指定時のみ含まれる）'),
  "ownerMemos": zod.array(zod.object({
  "id": zod.number().describe('オーナーメモID'),
  "ownerId": zod.string().describe('メモ対象のオーナーID'),
  "propertyId": zod.number().describe('メモ対象の物件ID'),
  "roomId": zod.number().nullable().describe('メモ対象の部屋ID。null は物件全体に対するメモ'),
  "title": zod.string().min(1).describe('メモのタイトル'),
  "body": zod.string().min(1).describe('メモの本文'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "owner": zod.any().nullish().describe('メモ対象のオーナー情報（OwnerResponse 相当。取得指定時のみ含まれる）'),
  "property": zod.any().nullish().describe('メモ対象の物件情報（PropertyResponse 相当。取得指定時のみ含まれる）'),
  "room": zod.any().nullish().describe('メモ対象の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メモに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).optional().describe('部屋に紐づくオーナーメモの一覧（取得指定時のみ含まれる）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "tenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketListResponseTicketsItemTenantPhone1Max).regex(ticketListResponseTicketsItemTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketListResponseTicketsItemTenantPhone2Max).regex(ticketListResponseTicketsItemTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketListResponseTicketsItemTenantPhone3Max).regex(ticketListResponseTicketsItemTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketListResponseTicketsItemTenantPhone4Max).regex(ticketListResponseTicketsItemTenantPhone4RegExp),
  "phone5": zod.string().max(ticketListResponseTicketsItemTenantPhone5Max).regex(ticketListResponseTicketsItemTenantPhone5RegExp),
  "phone6": zod.string().max(ticketListResponseTicketsItemTenantPhone6Max).regex(ticketListResponseTicketsItemTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketListResponseTicketsItemTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketListResponseTicketsItemTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketListResponseTicketsItemTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketListResponseTicketsItemTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "ocAssignee": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketListResponseTicketsItemOcAssigneeNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketListResponseTicketsItemOcAssigneeDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketListResponseTicketsItemOcAssigneeRoleMax).regex(ticketListResponseTicketsItemOcAssigneeRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "ticketComments": zod.array(zod.object({
  "id": zod.number().describe('対応履歴ID'),
  "ticketId": zod.number().describe('紐づくチケットID'),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('この対応履歴を登録した時点のチケットステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "contactAt": zod.string().describe('連絡日時'),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullable().describe('連絡者(FROM)オーナーID'),
  "contactFromTenantId": zod.number().nullable().describe('連絡者(FROM)賃借人ID'),
  "contactFromAdminId": zod.string().nullable().describe('連絡者(FROM)管理者ID'),
  "contactFromText": zod.string().nullable().describe('連絡者(FROM)テキスト'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullable().describe('連絡者(TO)オーナーID'),
  "contactToTenantId": zod.number().nullable().describe('連絡者(TO)賃借人ID'),
  "contactToAdminId": zod.string().nullable().describe('連絡者(TO)管理者ID'),
  "contactToText": zod.string().nullable().describe('連絡者(TO)テキスト'),
  "content": zod.string().describe('連絡内容'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "contactFromOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactFromTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone1Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone2Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone3Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone4Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone4RegExp),
  "phone5": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone5Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone5RegExp),
  "phone6": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone6Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactFromAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactFromAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactFromAdminRoleMax).regex(ticketListResponseTicketsItemTicketCommentsItemContactFromAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "contactToOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone1Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone2Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone3Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone4Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone4RegExp),
  "phone5": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone5Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone5RegExp),
  "phone6": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone6Max).regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemTicketCommentsItemContactToTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketListResponseTicketsItemTicketCommentsItemContactToAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketListResponseTicketsItemTicketCommentsItemContactToAdminRoleMax).regex(ticketListResponseTicketsItemTicketCommentsItemContactToAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).nullish(),
  "ticketMessages": zod.array(zod.object({
  "id": zod.number().describe('チケットメッセージID'),
  "ticketId": zod.number().describe('紐づくチケットID'),
  "senderType": zod.enum(['owner', 'admin', 'system']).describe('送信者種別'),
  "message": zod.string().describe('メッセージ本文'),
  "readAt": zod.string().nullable().describe('既読日時（ISO8601）。null は未読'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "ownerId": zod.string().nullable().describe('送信者がオーナーの場合のオーナーID'),
  "adminId": zod.string().nullable().describe('送信者が管理者の場合の管理者ID'),
  "owner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "admin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketListResponseTicketsItemTicketMessagesItemAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketListResponseTicketsItemTicketMessagesItemAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketListResponseTicketsItemTicketMessagesItemAdminRoleMax).regex(ticketListResponseTicketsItemTicketMessagesItemAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "ticket": zod.any().nullish().describe('紐づくチケット情報（TicketResponse 相当。取得指定時のみ含まれる）'),
  "files": zod.array(zod.any().nullable()).optional().describe('メッセージに添付されたファイルの一覧（FileResponse 相当）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
})).nullish(),
  "contactFromOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).optional(),
  "contactFromTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemContactFromTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemContactFromTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketListResponseTicketsItemContactFromTenantPhone1Max).regex(ticketListResponseTicketsItemContactFromTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketListResponseTicketsItemContactFromTenantPhone2Max).regex(ticketListResponseTicketsItemContactFromTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketListResponseTicketsItemContactFromTenantPhone3Max).regex(ticketListResponseTicketsItemContactFromTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketListResponseTicketsItemContactFromTenantPhone4Max).regex(ticketListResponseTicketsItemContactFromTenantPhone4RegExp),
  "phone5": zod.string().max(ticketListResponseTicketsItemContactFromTenantPhone5Max).regex(ticketListResponseTicketsItemContactFromTenantPhone5RegExp),
  "phone6": zod.string().max(ticketListResponseTicketsItemContactFromTenantPhone6Max).regex(ticketListResponseTicketsItemContactFromTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketListResponseTicketsItemContactFromTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketListResponseTicketsItemContactFromTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketListResponseTicketsItemContactFromTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemContactFromTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketListResponseTicketsItemContactFromTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactFromAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketListResponseTicketsItemContactFromAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketListResponseTicketsItemContactFromAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketListResponseTicketsItemContactFromAdminRoleMax).regex(ticketListResponseTicketsItemContactFromAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "contactToOwner": zod.object({
  "id": zod.string().describe('オーナーID'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "name": zod.string().describe('オーナーの氏名（姓名を結合した表示用の値）'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "firstName": zod.string().describe('名'),
  "lastName": zod.string().describe('姓'),
  "firstNameKana": zod.string().nullable().describe('名カナ'),
  "lastNameKana": zod.string().nullable().describe('姓カナ'),
  "phoneNumber": zod.string().describe('電話番号（ハイフンなし）'),
  "emergencyPhoneNumber": zod.string().nullable().describe('緊急用電話番号（任意・ハイフンなし）'),
  "postalCode": zod.string().nullable().describe('郵便番号（ハイフンなし）'),
  "address": zod.string().describe('住所'),
  "ownerAttention": zod.string().nullable().describe('オーナー対応時の注意事項'),
  "excludeAutoApproved": zod.string().nullable().describe('自動承認の対象外とするかどうか'),
  "adminMemo": zod.string().nullable().describe('管理者用メモ（社内用）'),
  "stripeCustomerId": zod.string().nullable().describe('Stripe側の顧客ID'),
  "echoesOwnerId": zod.string().nullable().describe('Echoes 連携オーナーのオーナーID。値があれば「エコーズプラン」として扱う'),
  "echoesLinkedAt": zod.string().nullable().describe('Echoes 連携完了日時（ISO8601）。null は未連携'),
  "echoesUpdatedAt": zod.string().nullable().describe('最後に取り込んだ Echoes 側オーナーの updated_at（ISO8601）。null は未同期'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期(オーナー単位の pull)に最後に失敗した日時（ISO8601）。成功時は null'),
  "properties": zod.array(zod.any().nullable()).optional().describe('オーナーが所有する物件一覧（取得指定時のみ含まれる）'),
  "operationRules": zod.array(zod.any().nullable()).optional().describe('運用ルール一覧(既定 + 物件固有。propertyId=null が既定で先頭、以降は物件ID昇順)。取得指定時のみ含まれる'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToTenant": zod.object({
  "id": zod.number().describe('賃借人ID'),
  "roomId": zod.number().describe('入居先の部屋ID'),
  "name": zod.string().describe('賃借人の氏名'),
  "nameKana": zod.string().min(1).regex(ticketListResponseTicketsItemContactToTenantNameKanaRegExp).describe('賃借人の氏名カナ'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemContactToTenantBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "phone1": zod.string().min(1).max(ticketListResponseTicketsItemContactToTenantPhone1Max).regex(ticketListResponseTicketsItemContactToTenantPhone1RegExp).describe('電話番号の市外局番'),
  "phone2": zod.string().min(1).max(ticketListResponseTicketsItemContactToTenantPhone2Max).regex(ticketListResponseTicketsItemContactToTenantPhone2RegExp).describe('電話番号の市内局番'),
  "phone3": zod.string().min(1).max(ticketListResponseTicketsItemContactToTenantPhone3Max).regex(ticketListResponseTicketsItemContactToTenantPhone3RegExp).describe('電話番号の加入者番号'),
  "phone4": zod.string().max(ticketListResponseTicketsItemContactToTenantPhone4Max).regex(ticketListResponseTicketsItemContactToTenantPhone4RegExp),
  "phone5": zod.string().max(ticketListResponseTicketsItemContactToTenantPhone5Max).regex(ticketListResponseTicketsItemContactToTenantPhone5RegExp),
  "phone6": zod.string().max(ticketListResponseTicketsItemContactToTenantPhone6Max).regex(ticketListResponseTicketsItemContactToTenantPhone6RegExp),
  "email": zod.string().describe('賃借人のメールアドレス'),
  "startDate": zod.string().regex(ticketListResponseTicketsItemContactToTenantStartDateRegExp).describe('賃貸借契約の開始日（YYYY-MM-DD）'),
  "endDate": zod.string().regex(ticketListResponseTicketsItemContactToTenantEndDateRegExp).nullable().describe('賃貸借契約の終了日（YYYY-MM-DD）。null は契約中'),
  "endReason": zod.union([zod.literal('tenant_move_out'),zod.literal('owner_change'),zod.literal(null)]).nullable().describe('契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）'),
  "rent": zod.number().describe('家賃（円・月額）'),
  "commonAreaFee": zod.number().describe('共益費（円・月額）'),
  "isParking": zod.boolean().describe('駐車場契約の有無'),
  "parkingFee": zod.number().describe('駐車場料金（円・月額）'),
  "parkingNumber": zod.string().describe('駐車場の区画番号'),
  "otherFees": zod.array(zod.object({
  "label": zod.string(),
  "price": zod.number(),
  "tax": zod.number()
})).nullable().describe('その他費用の内訳（label:名目 / price:税抜金額(円) / tax:消費税額(円)）'),
  "purpose": zod.enum(['1', '2']).describe('用途（1:居住用 / 2:事業用）'),
  "adminMemo": zod.string().describe('管理者用メモ（社内用）'),
  "echoesTenantId": zod.string().nullable().describe('Echoes の入居者ID。null は Echoes 連携対象外'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes から最後に取り込んだレコードの更新日時（ISO8601）'),
  "echoesFailedAt": zod.string().nullable().describe('Echoes 同期に最後に失敗した日時（ISO8601）。成功時は null'),
  "room": zod.any().nullish().describe('入居先の部屋情報（RoomResponse 相当。取得指定時のみ含まれる）'),
  "plans": zod.array(zod.any().nullable()).optional().describe('賃借人に紐づくプランの一覧（PlanResponse 相当。取得指定時のみ含まれる。新しいものが先頭）'),
  "files": zod.array(zod.object({
  "id": zod.number().describe('ファイルID'),
  "ownerMemoId": zod.number().nullable().describe('紐づくオーナーメモID。null は当該用途のファイルではない'),
  "ticketMessageId": zod.number().nullable().describe('紐づくチケットメッセージID。null は当該用途のファイルではない'),
  "tenantId": zod.number().nullable().describe('紐づく賃借人ID。null は当該用途のファイルではない'),
  "tenantApplicationId": zod.number().nullable().describe('紐づく入居申込ID。null は当該用途のファイルではない'),
  "tenantFileType": zod.union([zod.literal('rental_contract'),zod.literal('important_matters'),zod.literal('other_image'),zod.literal(null)]).nullable().describe('賃借人まわりのファイル種別（rental_contract:賃貸借契約書 / important_matters:重要事項説明書 / other_image:その他画像）'),
  "path": zod.string().min(1).describe('ストレージ上の保存パス（S3オブジェクトキー）'),
  "fileName": zod.string().nullable().describe('アップロード時の元ファイル名'),
  "title": zod.string().nullable().describe('画面表示用のファイルタイトル'),
  "fileType": zod.string().nullable().describe('MIMEタイプ'),
  "fileSize": zod.number().nullable().describe('ファイルサイズ（バイト）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "echoesPath": zod.string().nullable().describe('Echoes 同期でコピーした契約書PDFの元パス。null は AgentCall でアップロードされたファイル'),
  "echoesUpdatedAt": zod.string().nullable().describe('Echoes 側 contract_pdf の updated_at（ISO8601）。null は Echoes 同期ではないファイル'),
  "url": zod.string().describe('ファイル取得用の署名付きURL（一定時間で失効する）')
})).optional().describe('賃借人に紐づくファイルの一覧（契約書など）'),
  "occupants": zod.array(zod.object({
  "id": zod.number().describe('入居者ID'),
  "tenantId": zod.number().describe('紐づく賃借人ID'),
  "name": zod.string().describe('入居者の氏名'),
  "nameKana": zod.string().describe('入居者の氏名カナ。未提供時は空文字'),
  "phone": zod.string().max(ticketListResponseTicketsItemContactToTenantOccupantsItemPhoneMax).nullable().describe('入居者の電話番号。null は未提供'),
  "birthday": zod.string().regex(ticketListResponseTicketsItemContactToTenantOccupantsItemBirthdayRegExp).nullable().describe('生年月日（YYYY-MM-DD）'),
  "note": zod.string().max(ticketListResponseTicketsItemContactToTenantOccupantsItemNoteMax).nullable().describe('入居者の備考。null は未提供'),
  "gender": zod.union([zod.literal('male'),zod.literal('female'),zod.literal('other'),zod.literal(null)]).nullable().describe('性別（male:男性 / female:女性 / other:その他）。null は未提供')
})).optional().describe('賃借人に紐づく入居者の一覧（取得指定時のみ）'),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}).nullish(),
  "contactToAdmin": zod.object({
  "id": zod.string().describe('管理者ID'),
  "name": zod.string().describe('管理者の氏名'),
  "nameKana": zod.string().max(ticketListResponseTicketsItemContactToAdminNameKanaMax).nullable().describe('管理者の氏名カナ'),
  "department": zod.string().max(ticketListResponseTicketsItemContactToAdminDepartmentMax).nullable().describe('所属部署名'),
  "email": zod.string().describe('メールアドレス（ログインID）'),
  "emailVerified": zod.boolean().describe('メールアドレス確認済みかどうか'),
  "image": zod.string().nullable().describe('プロフィール画像URL'),
  "role": zod.string().min(1).max(ticketListResponseTicketsItemContactToAdminRoleMax).regex(ticketListResponseTicketsItemContactToAdminRoleRegExp).describe('権限ロール。組織ごとに定義される。既定値は system_admin:システム管理者 / sales:営業 / oc_admin:OC管理者 / oc_operator_day:OCオペレーター(日中) / oc_operator_emergency:OCオペレーター(緊急)'),
  "banned": zod.boolean().nullable().describe('利用停止中かどうか'),
  "banReason": zod.string().nullable().describe('利用停止の理由'),
  "banExpires": zod.string().nullable().describe('利用停止の解除日時（ISO8601）'),
  "createdAt": zod.string().describe('作成日時（ISO8601）'),
  "updatedAt": zod.string().describe('更新日時（ISO8601）'),
  "deletedAt": zod.string().nullable().describe('削除日時（ISO8601）。null は未削除'),
  "organizationName": zod.string().nullish().describe('所属組織名（withOrganization 指定時のみ含まれる。所属がなければ null）')
}).nullish(),
  "fixMe": zod.string().optional(),
  "fixMes": zod.array(zod.string()).optional()
}))
})


/**
 * @summary ticketCreate
 */
export const ticketCreateBodyContentMax = 1000;
export const ticketCreateBodyAlertCommentMax = 1000;
export const ticketCreateBodyOcCommentMax = 1000;
export const ticketCreateBodyContactFromTextMax = 255;
export const ticketCreateBodyContactToTextMax = 255;
export const ticketCreateBodyNoteMax = 1000;


export const ticketCreateBody = zod.object({
  "ownerId": zod.string().describe('対象オーナーID'),
  "propertyId": zod.number().describe('対象物件ID'),
  "roomId": zod.number().nullable().describe('対象部屋ID。部屋が特定できない場合は null'),
  "title": zod.string().min(1).describe('チケットの件名'),
  "content": zod.string().max(ticketCreateBodyContentMax).describe('問い合わせ・依頼の内容'),
  "category": zod.enum(['toiawase', 'kaiyaku-kanren', 'kuremu-hado', 'kuremu-sofuto', 'sonota', 'sabisu-ni-tsuite', 'shinki-nyukyosha-shonin', 'kaiyaku-uketsuke']).describe('カテゴリ（toiawase:問い合せ / kaiyaku-kanren:解約関連 / kuremu-hado:クレームハード / kuremu-sofuto:クレームソフト / sonota:その他 / sabisu-ni-tsuite:サービスについて / shinki-nyukyosha-shonin:新規入居者承認 / kaiyaku-uketsuke:解約受付）'),
  "subCategory": zod.enum(['kagi-autorokku', 'merubokkusu-takuhai-bokkusu', 'intanetto-terebi-denwa', 'eakon-kanren', 'setsubi-kanren-shiyo-hoho-to', 'chushajo-churinjo', 'yachin-suido-dai', 'hosho-gaisha', 'shorui-kankei', 'hoken', 'koshin-saikeiyaku', 'meigi-henko', 'nyukyosha-joho-henko', 'raifurain', 'kyoju-ruru', 'anpi-kyoju-kakunin', 'sonota-toiawase', 'kaiyaku-tetsuzuki-hoho', 'kaiyaku-bi-henko-torikeshi', 'taikyo-tachiai', 'taikyo-seisan', 'shikikin-henkin-koza-tenkyo-saki-jusho', 'eakon', 'kyutoki', 'nyukyoji-fuguai', 'mizumawari', 'toire-woshuretto', 'rosui', 'intahon-chaimu', 'konro', 'tategu', 'terebi', 'intanetto', 'kyoyobu', 'kagi-genkan', 'kanki-kanren', 'shomei-kigu', 'bureka-denki-kanren', 'keihoki', 'kurosu-yuka-tatami', 'kabi-ketsuro', 'chushajo', 'churinjo', 'so-on', 'gomi', 'shokubutsu', 'seibutsu', 'kitsuen', 'nioi', 'kyoyobu-no-shiyo-ni-tsuite-shibutsu', 'kyoyobu-no-yogore-seiso', 'sonota', 'sabisu-toiawase', 'shinki-keiyaku-shonin-kakunin', 'kaiyaku-uketsuke-kakunin']).describe('サブカテゴリ。category に紐づく詳細分類'),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('対応ステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "occurredAt": zod.string(),
  "alertAt": zod.string().optional(),
  "alertComment": zod.string().max(ticketCreateBodyAlertCommentMax).describe('アラートの内容'),
  "ocComment": zod.string().max(ticketCreateBodyOcCommentMax).describe('OC（オペレーションセンター）の対応コメント'),
  "ocAssigneeId": zod.string().nullable().describe('OC担当者の管理者ID'),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullish().describe('連絡元がオーナーの場合のオーナーID'),
  "contactFromTenantId": zod.number().nullish().describe('連絡元が賃借人の場合の賃借人ID'),
  "contactFromAdminId": zod.string().nullish().describe('連絡元が管理者の場合の管理者ID'),
  "contactFromText": zod.string().max(ticketCreateBodyContactFromTextMax).nullish().describe('連絡元をIDで특定できない場合の自由記述'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullish().describe('連絡先がオーナーの場合のオーナーID'),
  "contactToTenantId": zod.number().nullish().describe('連絡先が賃借人の場合の賃借人ID'),
  "contactToAdminId": zod.string().nullish().describe('連絡先が管理者の場合の管理者ID'),
  "contactToText": zod.string().max(ticketCreateBodyContactToTextMax).nullish().describe('連絡先をIDで特定できない場合の自由記述'),
  "note": zod.string().max(ticketCreateBodyNoteMax).describe('備考')
})


/**
 * @summary ticketAddProgress
 */
export const ticketAddProgressParams = zod.object({
  "id": zod.string()
})

export const ticketAddProgressBodyAlertCommentMax = 1000;
export const ticketAddProgressBodyOcCommentMax = 1000;
export const ticketAddProgressBodyContractorNameMax = 255;
export const ticketAddProgressBodyContractorContactMax = 255;
export const ticketAddProgressBodyContractorContactInfoMax = 500;
export const ticketAddProgressBodyContractorScheduledDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$');
export const ticketAddProgressBodyContractorNoteMax = 1000;


export const ticketAddProgressBody = zod.object({
  "title": zod.string().min(1).describe('チケットの件名'),
  "category": zod.enum(['toiawase', 'kaiyaku-kanren', 'kuremu-hado', 'kuremu-sofuto', 'sonota', 'sabisu-ni-tsuite', 'shinki-nyukyosha-shonin', 'kaiyaku-uketsuke']).describe('カテゴリ（toiawase:問い合せ / kaiyaku-kanren:解約関連 / kuremu-hado:クレームハード / kuremu-sofuto:クレームソフト / sonota:その他 / sabisu-ni-tsuite:サービスについて / shinki-nyukyosha-shonin:新規入居者承認 / kaiyaku-uketsuke:解約受付）'),
  "subCategory": zod.enum(['kagi-autorokku', 'merubokkusu-takuhai-bokkusu', 'intanetto-terebi-denwa', 'eakon-kanren', 'setsubi-kanren-shiyo-hoho-to', 'chushajo-churinjo', 'yachin-suido-dai', 'hosho-gaisha', 'shorui-kankei', 'hoken', 'koshin-saikeiyaku', 'meigi-henko', 'nyukyosha-joho-henko', 'raifurain', 'kyoju-ruru', 'anpi-kyoju-kakunin', 'sonota-toiawase', 'kaiyaku-tetsuzuki-hoho', 'kaiyaku-bi-henko-torikeshi', 'taikyo-tachiai', 'taikyo-seisan', 'shikikin-henkin-koza-tenkyo-saki-jusho', 'eakon', 'kyutoki', 'nyukyoji-fuguai', 'mizumawari', 'toire-woshuretto', 'rosui', 'intahon-chaimu', 'konro', 'tategu', 'terebi', 'intanetto', 'kyoyobu', 'kagi-genkan', 'kanki-kanren', 'shomei-kigu', 'bureka-denki-kanren', 'keihoki', 'kurosu-yuka-tatami', 'kabi-ketsuro', 'chushajo', 'churinjo', 'so-on', 'gomi', 'shokubutsu', 'seibutsu', 'kitsuen', 'nioi', 'kyoyobu-no-shiyo-ni-tsuite-shibutsu', 'kyoyobu-no-yogore-seiso', 'sonota', 'sabisu-toiawase', 'shinki-keiyaku-shonin-kakunin', 'kaiyaku-uketsuke-kakunin']).describe('サブカテゴリ。category に紐づく詳細分類'),
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('対応ステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "contactAt": zod.string(),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullish().describe('連絡者(FROM)オーナーID'),
  "contactFromTenantId": zod.number().nullish().describe('連絡者(FROM)賃借人ID'),
  "contactFromAdminId": zod.string().nullish().describe('連絡者(FROM)管理者ID'),
  "contactFromText": zod.string().nullish().describe('連絡者(FROM)テキスト'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullish().describe('連絡者(TO)オーナーID'),
  "contactToTenantId": zod.number().nullish().describe('連絡者(TO)賃借人ID'),
  "contactToAdminId": zod.string().nullish().describe('連絡者(TO)管理者ID'),
  "contactToText": zod.string().nullish().describe('連絡者(TO)テキスト'),
  "content": zod.string().describe('連絡内容'),
  "alertAt": zod.string().nullish(),
  "alertComment": zod.string().max(ticketAddProgressBodyAlertCommentMax).optional().describe('アラートの内容'),
  "ocComment": zod.string().max(ticketAddProgressBodyOcCommentMax).optional().describe('OC（オペレーションセンター）の対応コメント'),
  "ocAssigneeId": zod.string().nullable().describe('OC担当者の管理者ID'),
  "contractorStatus": zod.union([zod.literal('estimate_requested'),zod.literal('work_requested'),zod.literal('order_requested'),zod.literal('estimate_received'),zod.literal('owner_confirming'),zod.literal('completed'),zod.literal(null)]).nullish().describe('業者対応の進捗（estimate_requested:見積依頼中 / work_requested:業務依頼済 / order_requested:発注依頼済 / estimate_received:見積受領済 / owner_confirming:オーナー確認中 / completed:完了）'),
  "contractorType": zod.union([zod.literal('agentcall'),zod.literal('owner_specified'),zod.literal(null)]).nullish().describe('手配した業者の区分（agentcall:エージェントコール業者 / owner_specified:オーナー様指定業者）'),
  "contractorName": zod.string().max(ticketAddProgressBodyContractorNameMax).optional().describe('手配した業者名'),
  "contractorContact": zod.string().max(ticketAddProgressBodyContractorContactMax).optional().describe('手配した業者の担当者'),
  "contractorContactInfo": zod.string().max(ticketAddProgressBodyContractorContactInfoMax).optional().describe('手配した業者の連絡先'),
  "contractorScheduledDate": zod.string().regex(ticketAddProgressBodyContractorScheduledDateRegExp).nullish().describe('業者の対応予定日（YYYY-MM-DD）'),
  "contractorNote": zod.string().max(ticketAddProgressBodyContractorNoteMax).optional().describe('業者対応に関する備考')
})


/**
 * @summary ticketUpdateOcComment
 */
export const ticketUpdateOcCommentParams = zod.object({
  "id": zod.string()
})

export const ticketUpdateOcCommentBodyOcCommentMax = 1000;


export const ticketUpdateOcCommentBody = zod.object({
  "ocComment": zod.string().max(ticketUpdateOcCommentBodyOcCommentMax).describe('OC（オペレーションセンター）の対応コメント')
})


/**
 * @summary ticketReadMessage
 */
export const ticketReadMessageParams = zod.object({
  "id": zod.string()
})

export const ticketReadMessageBody = zod.object({
  "isRead": zod.boolean().describe('管理者がチケットのメッセージを読んだかどうか')
})


/**
 * @summary ticketCommentUpdate
 */
export const ticketCommentUpdatePathIdMin = 0;
export const ticketCommentUpdatePathTicketCommentIdMin = 0;


export const ticketCommentUpdateParams = zod.object({
  "id": zod.number().min(ticketCommentUpdatePathIdMin),
  "ticketCommentId": zod.number().min(ticketCommentUpdatePathTicketCommentIdMin)
})

export const ticketCommentUpdateBody = zod.object({
  "status": zod.enum(['oc_in_progress', 'owner_in_progress', 'contractor_in_progress', 'completed']).describe('この対応履歴を登録した時点のチケットステータス（oc_in_progress:OC対応中 / owner_in_progress:オーナー対応中 / contractor_in_progress:業者対応中 / completed:完了）'),
  "contactAt": zod.string().describe('連絡日時'),
  "contactType": zod.enum(['phone', 'email', 'sms', 'chat', 'fax', 'other']).describe('連絡手段（phone:電話 / email:メール / sms:SMS / chat:チャット / fax:FAX / other:その他）'),
  "contactFromCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡元の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactFromOwnerId": zod.string().nullish().describe('連絡者(FROM)オーナーID'),
  "contactFromTenantId": zod.number().nullish().describe('連絡者(FROM)賃借人ID'),
  "contactFromAdminId": zod.string().nullish().describe('連絡者(FROM)管理者ID'),
  "contactFromText": zod.string().nullish().describe('連絡者(FROM)テキスト'),
  "contactToCategory": zod.enum(['owner', 'tenant', 'resident', 'oc', 'contractor', 'emergency', 'other']).describe('連絡先の区分（owner:オーナー / tenant:賃借人 / resident:入居者(賃借人以外) / oc:OC / contractor:業者 / emergency:緊急連絡センター / other:その他）'),
  "contactToOwnerId": zod.string().nullish().describe('連絡者(TO)オーナーID'),
  "contactToTenantId": zod.number().nullish().describe('連絡者(TO)賃借人ID'),
  "contactToAdminId": zod.string().nullish().describe('連絡者(TO)管理者ID'),
  "contactToText": zod.string().nullish().describe('連絡者(TO)テキスト'),
  "content": zod.string().describe('連絡内容')
})


/**
 * @summary ticketCommentDelete
 */
export const ticketCommentDeletePathIdMin = 0;
export const ticketCommentDeletePathTicketCommentIdMin = 0;


export const ticketCommentDeleteParams = zod.object({
  "id": zod.number().min(ticketCommentDeletePathIdMin),
  "ticketCommentId": zod.number().min(ticketCommentDeletePathTicketCommentIdMin)
})
